import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISODate: any;
  JSON: any;
};

export type Alarm = {
  __typename?: 'Alarm';
  code: Scalars['String'];
  id: Scalars['ID'];
  item?: Maybe<Item>;
  itemId?: Maybe<Scalars['ID']>;
  machine?: Maybe<Machine>;
  machineId: Scalars['ID'];
  name: Scalars['String'];
  time: Scalars['ISODate'];
};

export type AlarmFilter = {
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  itemId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<StringFilter>;
  time?: InputMaybe<DateFilter>;
};

export type AlarmOrdering = {
  code?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  time?: InputMaybe<Order>;
};

export type AlarmQueryResponse = {
  __typename?: 'AlarmQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Alarm>>;
};

export type Application = {
  __typename?: 'Application';
  createdAt: Scalars['ISODate'];
  deletedAt?: Maybe<Scalars['ISODate']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  secretKey: Scalars['String'];
  updatedAt: Scalars['ISODate'];
};

export type ApplicationAuthentication = {
  __typename?: 'ApplicationAuthentication';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  token: Scalars['String'];
};

export type ApplicationFilter = {
  hasPermission?: InputMaybe<Scalars['String']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ApplicationQueryResponse = {
  __typename?: 'ApplicationQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Application>>;
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type CapacityTrend = {
  __typename?: 'CapacityTrend';
  capacityAfter: Scalars['Float'];
  capacityBefore: Scalars['Float'];
  capacityLimit: Scalars['Float'];
  machineId: Scalars['ID'];
  machineName: Scalars['String'];
  overMinutes: Scalars['Int'];
};

export type Conveyor = {
  __typename?: 'Conveyor';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  conveyorStates?: Maybe<Array<ConveyorState>>;
  createdAt: Scalars['ISODate'];
  handleFrom: Scalars['String'];
  handleTo: Scalars['String'];
  id: Scalars['ID'];
  origin?: Maybe<Machine>;
  originId?: Maybe<Scalars['ID']>;
  target?: Maybe<Machine>;
  targetId?: Maybe<Scalars['ID']>;
  type: ConveyorType;
  updatedAt: Scalars['ISODate'];
};

export type ConveyorFilter = {
  lineId?: InputMaybe<Scalars['ID']>;
};

export type ConveyorQueryResponse = {
  __typename?: 'ConveyorQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Conveyor>>;
};

export type ConveyorState = {
  __typename?: 'ConveyorState';
  conveyor?: Maybe<Conveyor>;
  conveyorId: Scalars['ID'];
  details: Scalars['JSON'];
  speed: Scalars['Float'];
  timestampAt: Scalars['ISODate'];
};

export type ConveyorStateFilter = {
  speed?: InputMaybe<FloatFilter>;
};

export type ConveyorStateOrdering = {
  speed?: InputMaybe<Order>;
};

export type ConveyorStateQueryResponse = {
  __typename?: 'ConveyorStateQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ConveyorState>>;
};

export enum ConveyorType {
  Belt = 'BELT',
  Freight = 'FREIGHT',
  Lifter = 'LIFTER',
  Manual = 'MANUAL',
  Roller = 'ROLLER'
}

export type ConveyorTypeFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateAdminInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  secret: Scalars['String'];
};

export type CreateAlarmInput = {
  code: Scalars['String'];
  itemCode?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  machineId: Scalars['ID'];
  name: Scalars['String'];
  time?: InputMaybe<Scalars['ISODate']>;
};

export type CreateApplicationInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']>>;
  secretKey: Scalars['String'];
};

export type CreateConveyorInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  handleFrom: Scalars['String'];
  handleTo: Scalars['String'];
  originId?: InputMaybe<Scalars['ID']>;
  targetId?: InputMaybe<Scalars['ID']>;
  type: ConveyorType;
};

export type CreateConveyorStateInput = {
  conveyorId: Scalars['ID'];
  details: Scalars['JSON'];
  speed: Scalars['Float'];
  timestampAt: Scalars['ISODate'];
};

export type CreateEventThresholdsInput = {
  normalCycle: Scalars['Float'];
  smallStopCycle: Scalars['Float'];
  stopCycle: Scalars['Float'];
};

export type CreateFactoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  name: Scalars['String'];
  timezone: Scalars['String'];
};

export type CreateGroupInput = {
  factoryId: Scalars['ID'];
  lineId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  sector: Sector;
  workShift: WorkShift;
};

export type CreateItemInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  itemTypeId: Scalars['ID'];
};

export type CreateItemTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateLineInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  factoryId: Scalars['ID'];
  name: Scalars['String'];
  stopsThreshold: Scalars['Float'];
};

export type CreateMachineInput = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  idealCycleTime: Scalars['Float'];
  lineId: Scalars['ID'];
  mandatoryJustification: Scalars['Boolean'];
  name: Scalars['String'];
  normalCycle: Scalars['Float'];
  positionX?: InputMaybe<Scalars['Int']>;
  positionY?: InputMaybe<Scalars['Int']>;
  possibleDefects?: InputMaybe<Array<Scalars['String']>>;
  possibleProblems: Array<PossibleProblemInput>;
  smallStopCycle: Scalars['Float'];
  stopCycle: Scalars['Float'];
  unit: Unit;
};

export type CreateMachineStateInput = {
  amount: Scalars['Float'];
  availability: Scalars['Float'];
  delta: Scalars['Float'];
  elapsedTime: Scalars['Float'];
  hasChangedStatus?: InputMaybe<Scalars['Boolean']>;
  isInstantBottleneck?: InputMaybe<Scalars['Boolean']>;
  itemCode?: InputMaybe<Scalars['String']>;
  itemTypeCode?: InputMaybe<Scalars['String']>;
  machineId: Scalars['ID'];
  meanDelta: Scalars['Float'];
  meanSpeed: Scalars['Float'];
  oee: Scalars['Float'];
  performance: Scalars['Float'];
  previousRunDelta: Scalars['Float'];
  previousStatus: MachineStatus;
  production: Scalars['Float'];
  projection: Scalars['Float'];
  remainingTime: Scalars['Float'];
  runDelta: Scalars['Float'];
  smallStopCount: Scalars['Int'];
  smallStopTime: Scalars['Float'];
  speed: Scalars['Float'];
  status: MachineStatus;
  stopCount: Scalars['Int'];
  stopTime: Scalars['Float'];
  time: Scalars['ISODate'];
  workShift: WorkShift;
};

export type CreateMetadataNotificationInput = {
  duration?: InputMaybe<Scalars['Float']>;
};

export type CreateNotificationInput = {
  lineId: Scalars['ID'];
  message: Scalars['String'];
  metadata?: InputMaybe<CreateMetadataNotificationInput>;
  originId?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  time: Scalars['ISODate'];
  title: Scalars['String'];
  type: NotificationType;
};

export type CreateParameterFileInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  downloadSize: Scalars['Int'];
  itemCode?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  itemTypeCode?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  parameterCode?: InputMaybe<Scalars['String']>;
  parameterId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateParameterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  inferiorLimit?: InputMaybe<Scalars['Float']>;
  machineId: Scalars['ID'];
  name: Scalars['String'];
  superiorLimit?: InputMaybe<Scalars['Float']>;
  type: ParameterType;
  unit: Unit;
};

export type CreateParameterValueInput = {
  itemCode?: InputMaybe<Scalars['String']>;
  itemTypeCode?: InputMaybe<Scalars['String']>;
  machineId?: InputMaybe<Scalars['ID']>;
  parameterCode?: InputMaybe<Scalars['String']>;
  parameterId?: InputMaybe<Scalars['ID']>;
  time: Scalars['ISODate'];
  value: Scalars['Float'];
};

export type CreateRuntimeOptionsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  eventThresholds: CreateEventThresholdsInput;
  machineId: Scalars['ID'];
  scheduleOptions?: InputMaybe<CreateScheduleOptionsInput>;
};

export type CreateScheduleOptionsInput = {
  shiftAStartsAt: Scalars['Int'];
  shiftBStartsAt: Scalars['Int'];
  shiftCStartsAt: Scalars['Int'];
};

export type CreateScrapInformationInput = {
  description?: InputMaybe<Scalars['String']>;
  detectorGroup?: InputMaybe<Scalars['String']>;
  factory?: InputMaybe<Scalars['ID']>;
  generatorGroup?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Scalars['String']>;
  line?: InputMaybe<Scalars['ID']>;
  scrapPossibleFailure?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
};

export type CreateScrapInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  date: Scalars['ISODate'];
  details?: InputMaybe<CreateScrapInformationInput>;
  machineId: Scalars['ID'];
  workShift: WorkShift;
};

export type CreateScrapPossibleFailureInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateSmallStopJustificationInput = {
  description?: InputMaybe<Scalars['String']>;
  loss: Scalars['String'];
  machine: Scalars['ID'];
  reason: Scalars['String'];
  stop: Scalars['String'];
  user: Scalars['String'];
};

export type CreateStopJustificationInput = {
  affectAvailability: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  loss: Scalars['String'];
  machine: Scalars['ID'];
  reason: Scalars['String'];
  stop: Scalars['String'];
  user: Scalars['String'];
};

export type CreateStopTagInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  tagType: StopTagType;
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
  permissions: Array<Scalars['ID']>;
  profile: UserProfile;
};

export enum CurrentState {
  Bottleneck = 'BOTTLENECK',
  Normal = 'NORMAL',
  NotMonitored = 'NOT_MONITORED',
  Slow = 'SLOW',
  Stopped = 'STOPPED'
}

export type CycleTimeResponse = {
  __typename?: 'CycleTimeResponse';
  count: Scalars['Int'];
  delta: Scalars['Float'];
};

export type DateFilter = {
  eq?: InputMaybe<Scalars['ISODate']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['ISODate']>;
  gte?: InputMaybe<Scalars['ISODate']>;
  in?: InputMaybe<Array<Scalars['ISODate']>>;
  lt?: InputMaybe<Scalars['ISODate']>;
  lte?: InputMaybe<Scalars['ISODate']>;
  neq?: InputMaybe<Scalars['ISODate']>;
  notIn?: InputMaybe<Array<Scalars['ISODate']>>;
};

export type Details = {
  __typename?: 'Details';
  amount?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type EventThresholds = {
  __typename?: 'EventThresholds';
  normalCycle: Scalars['Float'];
  smallStopCycle: Scalars['Float'];
  stopCycle: Scalars['Float'];
};

export type Factory = {
  __typename?: 'Factory';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['ISODate'];
  id: Scalars['ID'];
  lines?: Maybe<Array<Line>>;
  name: Scalars['String'];
  timezone: Scalars['String'];
  updatedAt: Scalars['ISODate'];
};

export type FactoryFilter = {
  active?: InputMaybe<BooleanFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  id?: InputMaybe<IdFilter>;
  lines?: InputMaybe<RelationFilter>;
  name?: InputMaybe<StringFilter>;
  timezone?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type FactoryOrdering = {
  code?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  timezone?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type FactoryQueryResponse = {
  __typename?: 'FactoryQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Factory>>;
};

export type FloatFilter = {
  closeTo?: InputMaybe<FloatPrecision>;
  exists?: InputMaybe<Scalars['Boolean']>;
  farFrom?: InputMaybe<FloatPrecision>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type FloatPrecision = {
  precision?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FullStatus = {
  __typename?: 'FullStatus';
  normal: Scalars['Float'];
  slow: Scalars['Float'];
  stop: Scalars['Float'];
};

export type Group = {
  __typename?: 'Group';
  createdAt: Scalars['ISODate'];
  factory?: Maybe<Factory>;
  factoryId: Scalars['ID'];
  id: Scalars['ID'];
  line?: Maybe<Line>;
  lineId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  sector: Sector;
  updatedAt: Scalars['ISODate'];
  users?: Maybe<Array<User>>;
  workShift: WorkShift;
};

export type GroupFilter = {
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type GroupOrdering = {
  createdAt?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type GroupQueryResponse = {
  __typename?: 'GroupQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Group>>;
};

export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  neq?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type IdealCycleTimeChartFilter = {
  endDate?: InputMaybe<Scalars['ISODate']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  minCount?: InputMaybe<Scalars['Int']>;
  onlyIfStatusChanged?: InputMaybe<Scalars['Boolean']>;
  onlyLastMachine?: InputMaybe<Scalars['Boolean']>;
  onlyLastOfWorkShift?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  status?: InputMaybe<MachineStatus>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Item = {
  __typename?: 'Item';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['ISODate'];
  hasBeenFinished: Scalars['Boolean'];
  id: Scalars['ID'];
  itemTypeId: Scalars['ID'];
  parameterFiles?: Maybe<Array<Maybe<ParameterFile>>>;
  parametersValues?: Maybe<Array<Maybe<ParameterValue>>>;
  type?: Maybe<ItemType>;
  updatedAt: Scalars['ISODate'];
};

export type ItemFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  itemTypeId?: InputMaybe<Scalars['ID']>;
};

export type ItemOrType = Item | ItemType;

export type ItemQueryResponse = {
  __typename?: 'ItemQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Item>>;
};

export type ItemType = {
  __typename?: 'ItemType';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['ISODate'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  name: Scalars['String'];
  updatedAt: Scalars['ISODate'];
};

export type ItemTypeFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISODate']>;
};

export type ItemTypeOrdering = {
  active?: InputMaybe<Order>;
  code?: InputMaybe<Order>;
  createdAt?: InputMaybe<Order>;
  description?: InputMaybe<Order>;
  id?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  updatedAt?: InputMaybe<Order>;
};

export type ItemTypeQueryResponse = {
  __typename?: 'ItemTypeQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ItemType>>;
};

export type JustifiableSmallStop = {
  __typename?: 'JustifiableSmallStop';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISODate'];
  endedAt?: Maybe<Scalars['ISODate']>;
  id: Scalars['ID'];
  justification?: Maybe<SmallStopJustification>;
  machine?: Maybe<Machine>;
  machineId: Scalars['ID'];
  startedAt: Scalars['ISODate'];
  state: JustificationState;
  updatedAt: Scalars['ISODate'];
  workShift?: Maybe<WorkShift>;
};

export type JustifiableSmallStopFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  loss?: InputMaybe<Array<Scalars['String']>>;
  machineId?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  states?: InputMaybe<Array<JustificationState>>;
  stop?: InputMaybe<Array<Scalars['String']>>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type JustifiableSmallStopQueryResponse = {
  __typename?: 'JustifiableSmallStopQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<JustifiableSmallStop>>;
};

export type JustifiableStop = {
  __typename?: 'JustifiableStop';
  active: Scalars['Boolean'];
  affectAvailability: Scalars['Boolean'];
  createdAt: Scalars['ISODate'];
  endedAt?: Maybe<Scalars['ISODate']>;
  id: Scalars['ID'];
  justification?: Maybe<StopJustification>;
  line?: Maybe<Line>;
  lineId: Scalars['ID'];
  machine?: Maybe<Machine>;
  machineId?: Maybe<Scalars['ID']>;
  startedAt: Scalars['ISODate'];
  state: JustificationState;
  updatedAt: Scalars['ISODate'];
  workShift?: Maybe<WorkShift>;
};

export type JustifiableStopFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectAvailability?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  loss?: InputMaybe<Array<Scalars['String']>>;
  machineId?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  states?: InputMaybe<Array<JustificationState>>;
  stop?: InputMaybe<Array<Scalars['String']>>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type JustifiableStopQueryResponse = {
  __typename?: 'JustifiableStopQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<JustifiableStop>>;
};

export enum JustificationState {
  Expired = 'EXPIRED',
  Justified = 'JUSTIFIED',
  NotJustifiable = 'NOT_JUSTIFIABLE',
  Pending = 'PENDING'
}

export type JustificationStateFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Line = {
  __typename?: 'Line';
  autoBottleneckMachine?: Maybe<Scalars['Boolean']>;
  autoLastMachine?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  createdAt: Scalars['ISODate'];
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  factory?: Maybe<Factory>;
  factoryId: Scalars['ID'];
  hasAccess?: Maybe<Array<User>>;
  hasAnyData?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  justifiableStops?: Maybe<Array<JustifiableStop>>;
  lastMachine?: Maybe<Machine>;
  lastMachineId?: Maybe<Scalars['ID']>;
  machines?: Maybe<Array<Machine>>;
  name: Scalars['String'];
  newLastMachine?: Maybe<Machine>;
  newLastMachineAuto?: Maybe<Scalars['Boolean']>;
  newLastMachineId?: Maybe<Scalars['ID']>;
  nominalBottleneck?: Maybe<Machine>;
  stopsThreshold: Scalars['Float'];
  updatedAt: Scalars['ISODate'];
};

export type LineFilter = {
  code?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  hasAnyData?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
};

export type LineOrdering = {
  active?: InputMaybe<Order>;
  code?: InputMaybe<Order>;
  description?: InputMaybe<Order>;
  factoryId?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
};

export type LineQueryResponse = {
  __typename?: 'LineQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Line>>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profile: UserProfile;
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type Machine = {
  __typename?: 'Machine';
  code: Scalars['String'];
  createdAt: Scalars['ISODate'];
  currentRuntimeOptions?: Maybe<RuntimeOptions>;
  currentState?: Maybe<MachineState>;
  deletedAt?: Maybe<Scalars['ISODate']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idealCycleTime: Scalars['Float'];
  inputConveyors?: Maybe<Array<Conveyor>>;
  justifiableSmallStops?: Maybe<Array<JustifiableSmallStop>>;
  lastItemTime?: Maybe<Scalars['ISODate']>;
  lastStateOfShift?: Maybe<MachineState>;
  line?: Maybe<Line>;
  lineId: Scalars['ID'];
  mandatoryJustification: Scalars['Boolean'];
  maxSpeed?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  outputConveyors?: Maybe<Array<Conveyor>>;
  parameters?: Maybe<Array<Parameter>>;
  positionX?: Maybe<Scalars['Int']>;
  positionY?: Maybe<Scalars['Int']>;
  possibleDefects?: Maybe<Array<Scalars['String']>>;
  possibleProblems: Array<PossibleProblem>;
  runtimeOptions?: Maybe<Array<RuntimeOptions>>;
  scraps?: Maybe<Array<Scrap>>;
  states?: Maybe<Array<MachineState>>;
  unit: Unit;
  updatedAt: Scalars['ISODate'];
};


export type MachineCurrentStateArgs = {
  onlyCurrentShift?: InputMaybe<Scalars['Boolean']>;
};


export type MachineLastStateOfShiftArgs = {
  date: Scalars['ISODate'];
  workShift: WorkShift;
};

export type MachineFilter = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  lineId?: InputMaybe<Scalars['ID']>;
};

export type MachineParameter = {
  machine: Scalars['String'];
  machineId: Scalars['ID'];
  parameterId?: InputMaybe<Array<Scalars['ID']>>;
};

export type MachineParameterValue = {
  __typename?: 'MachineParameterValue';
  date: Scalars['ISODate'];
  value: Scalars['Float'];
};

export type MachineQueryResponse = {
  __typename?: 'MachineQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Machine>>;
};

export type MachineState = {
  __typename?: 'MachineState';
  amount: Scalars['Float'];
  availability: Scalars['Float'];
  delta: Scalars['Float'];
  elapsedTime: Scalars['Float'];
  hasChangedStatus?: Maybe<Scalars['Boolean']>;
  isInstantBottleneck?: Maybe<Scalars['Boolean']>;
  isLastMachine?: Maybe<Scalars['Boolean']>;
  isLastOfWorkShift?: Maybe<Scalars['Boolean']>;
  isNominalBottleneck?: Maybe<Scalars['Boolean']>;
  item?: Maybe<Item>;
  itemId?: Maybe<Scalars['ID']>;
  itemType?: Maybe<ItemType>;
  lossHP?: Maybe<Scalars['Float']>;
  lossProduction?: Maybe<Scalars['Int']>;
  machine?: Maybe<Machine>;
  machineId: Scalars['ID'];
  meanDelta: Scalars['Float'];
  meanSpeed: Scalars['Float'];
  oee: Scalars['Float'];
  performance: Scalars['Float'];
  previousRunDelta: Scalars['Float'];
  previousStatus: MachineStatus;
  production: Scalars['Float'];
  projection: Scalars['Float'];
  remainingTime: Scalars['Float'];
  runDelta: Scalars['Float'];
  smallStopCount: Scalars['Int'];
  smallStopTime: Scalars['Float'];
  speed: Scalars['Float'];
  status: MachineStatus;
  stopCount: Scalars['Int'];
  stopTime: Scalars['Float'];
  time: Scalars['ISODate'];
  workShift: WorkShift;
};

export type MachineStateFilter = {
  endDate?: InputMaybe<Scalars['ISODate']>;
  itemId?: InputMaybe<Scalars['ID']>;
  itemTypeId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  minCount?: InputMaybe<Scalars['Int']>;
  onlyCurrentShift?: InputMaybe<Scalars['Boolean']>;
  onlyIfStatusChanged?: InputMaybe<Scalars['Boolean']>;
  onlyLastMachine?: InputMaybe<Scalars['Boolean']>;
  onlyLastOfWorkShift?: InputMaybe<Scalars['Boolean']>;
  productionHistoryFilter?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  status?: InputMaybe<MachineStatus>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type MachineStateQueryResponse = {
  __typename?: 'MachineStateQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<MachineState>>;
};

export enum MachineStatus {
  Normal = 'NORMAL',
  NotMonitored = 'NOT_MONITORED',
  Paused = 'PAUSED',
  Slow = 'SLOW',
  SmallStop = 'SMALL_STOP',
  Startup = 'STARTUP',
  Stop = 'STOP'
}

export type MachineStatusFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Me = {
  __typename?: 'Me';
  email: Scalars['String'];
  firstName: Scalars['String'];
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  profile: UserProfile;
};

export type MetadataNotification = {
  __typename?: 'MetadataNotification';
  duration?: Maybe<Scalars['Float']>;
};

export type Metric = {
  __typename?: 'Metric';
  capacity: Scalars['Float'];
  loss: Scalars['Float'];
  production: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticateApplication?: Maybe<ApplicationAuthentication>;
  bulkCreateMachineStates?: Maybe<Scalars['Int']>;
  createAdmin?: Maybe<User>;
  createAlarm?: Maybe<Alarm>;
  createApplication?: Maybe<Application>;
  createConveyor?: Maybe<Conveyor>;
  createConveyorState?: Maybe<ConveyorState>;
  createFactory?: Maybe<Factory>;
  createGroup?: Maybe<Group>;
  createItem: Item;
  createItemType: ItemType;
  createLine?: Maybe<Line>;
  createMachine?: Maybe<Machine>;
  createMachineState?: Maybe<MachineState>;
  createNotification?: Maybe<Notification>;
  createParameter?: Maybe<Parameter>;
  createParameterFile?: Maybe<ParameterFile>;
  createParameterValue?: Maybe<ParameterValue>;
  createRuntimeOptions?: Maybe<RuntimeOptions>;
  createScrap?: Maybe<Scrap>;
  createScrapPossibleFailure?: Maybe<ScrapPossibleFailure>;
  createStopTag?: Maybe<StopTag>;
  createUser?: Maybe<User>;
  deleteAlarm?: Maybe<Alarm>;
  deleteApplication?: Maybe<Application>;
  deleteConveyor?: Maybe<Conveyor>;
  deleteConveyorState?: Maybe<ConveyorState>;
  deleteFactory?: Maybe<Factory>;
  deleteGroup?: Maybe<Group>;
  deleteItem: Item;
  deleteItemType: ItemType;
  deleteLine?: Maybe<Line>;
  deleteMachine?: Maybe<Machine>;
  deleteNotification?: Maybe<Notification>;
  deleteParameter?: Maybe<Parameter>;
  deleteParameterFile?: Maybe<ParameterFile>;
  deleteScrap?: Maybe<Scrap>;
  deleteScrapPossibleFailure?: Maybe<ScrapPossibleFailure>;
  deleteStopTag?: Maybe<StopTag>;
  deleteUser?: Maybe<User>;
  disableLine?: Maybe<Line>;
  disableMachine?: Maybe<Machine>;
  justifySmallStop?: Maybe<JustifiableSmallStop>;
  justifyStop?: Maybe<JustifiableStop>;
  login?: Maybe<LoginResponse>;
  recoverPassword?: Maybe<Scalars['Boolean']>;
  refresh?: Maybe<TokenResponse>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  updateApplication?: Maybe<Application>;
  updateConveyor?: Maybe<Conveyor>;
  updateConveyorState?: Maybe<ConveyorState>;
  updateFactory?: Maybe<Factory>;
  updateGroup?: Maybe<Group>;
  updateItem: Item;
  updateItemType: ItemType;
  updateLastMachine?: Maybe<Line>;
  updateLine?: Maybe<Line>;
  updateMachine?: Maybe<Machine>;
  updateParameter?: Maybe<Parameter>;
  updateParameterFile?: Maybe<ParameterFile>;
  updateScrap?: Maybe<Scrap>;
  updateScrapPossibleFailure?: Maybe<ScrapPossibleFailure>;
  updateStopTag?: Maybe<StopTag>;
  updateUser?: Maybe<User>;
};


export type MutationAuthenticateApplicationArgs = {
  id: Scalars['ID'];
  secretKey: Scalars['String'];
};


export type MutationBulkCreateMachineStatesArgs = {
  machineStates: Array<CreateMachineStateInput>;
};


export type MutationCreateAdminArgs = {
  admin: CreateAdminInput;
};


export type MutationCreateAlarmArgs = {
  alarm: CreateAlarmInput;
};


export type MutationCreateApplicationArgs = {
  application: CreateApplicationInput;
};


export type MutationCreateConveyorArgs = {
  conveyor: CreateConveyorInput;
};


export type MutationCreateConveyorStateArgs = {
  conveyorState: CreateConveyorStateInput;
};


export type MutationCreateFactoryArgs = {
  factory: CreateFactoryInput;
};


export type MutationCreateGroupArgs = {
  group: CreateGroupInput;
};


export type MutationCreateItemArgs = {
  item: CreateItemInput;
};


export type MutationCreateItemTypeArgs = {
  itemType: CreateItemTypeInput;
};


export type MutationCreateLineArgs = {
  line: CreateLineInput;
};


export type MutationCreateMachineArgs = {
  machine: CreateMachineInput;
};


export type MutationCreateMachineStateArgs = {
  machineState: CreateMachineStateInput;
};


export type MutationCreateNotificationArgs = {
  notification: CreateNotificationInput;
};


export type MutationCreateParameterArgs = {
  parameter: CreateParameterInput;
};


export type MutationCreateParameterFileArgs = {
  parameterFile: CreateParameterFileInput;
};


export type MutationCreateParameterValueArgs = {
  parameterValue: CreateParameterValueInput;
};


export type MutationCreateRuntimeOptionsArgs = {
  runtimeOptions: CreateRuntimeOptionsInput;
};


export type MutationCreateScrapArgs = {
  scrap: CreateScrapInput;
};


export type MutationCreateScrapPossibleFailureArgs = {
  scrapPossibleFailure: CreateScrapPossibleFailureInput;
};


export type MutationCreateStopTagArgs = {
  stopTag: CreateStopTagInput;
};


export type MutationCreateUserArgs = {
  user: CreateUserInput;
};


export type MutationDeleteAlarmArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteApplicationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConveyorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConveyorStateArgs = {
  timestampAt: Scalars['ISODate'];
};


export type MutationDeleteFactoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteItemTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLineArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMachineArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteParameterArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteParameterFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScrapArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScrapPossibleFailureArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStopTagArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDisableLineArgs = {
  disabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationDisableMachineArgs = {
  disabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationJustifySmallStopArgs = {
  id: Scalars['ID'];
  justification: CreateSmallStopJustificationInput;
};


export type MutationJustifyStopArgs = {
  id: Scalars['ID'];
  justification: CreateStopJustificationInput;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationRecoverPasswordArgs = {
  email: Scalars['String'];
};


export type MutationRefreshArgs = {
  tokens: RefreshTokenInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationUpdateApplicationArgs = {
  application: UpdateApplicationInput;
  id: Scalars['ID'];
};


export type MutationUpdateConveyorArgs = {
  conveyor: UpdateConveyorInput;
  id: Scalars['ID'];
};


export type MutationUpdateConveyorStateArgs = {
  conveyorState: UpdateConveyorStateInput;
  timestampAt: Scalars['ISODate'];
};


export type MutationUpdateFactoryArgs = {
  factory: UpdateFactoryInput;
  id: Scalars['ID'];
};


export type MutationUpdateGroupArgs = {
  group: UpdateGroupInput;
  id: Scalars['ID'];
};


export type MutationUpdateItemArgs = {
  id: Scalars['ID'];
  item: UpdateItemInput;
};


export type MutationUpdateItemTypeArgs = {
  id: Scalars['ID'];
  itemType: UpdateItemTypeInput;
};


export type MutationUpdateLastMachineArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateLineArgs = {
  id: Scalars['ID'];
  line: UpdateLineInput;
};


export type MutationUpdateMachineArgs = {
  id: Scalars['ID'];
  machine: UpdateMachineInput;
};


export type MutationUpdateParameterArgs = {
  id: Scalars['ID'];
  parameter: UpdateParameterInput;
};


export type MutationUpdateParameterFileArgs = {
  id: Scalars['ID'];
  parameterFile: UpdateParameterFileInput;
};


export type MutationUpdateScrapArgs = {
  id: Scalars['ID'];
  scrap: UpdateScrapInput;
};


export type MutationUpdateScrapPossibleFailureArgs = {
  id: Scalars['ID'];
  scrapPossibleFailure: UpdateScrapPossibleFailureInput;
};


export type MutationUpdateStopTagArgs = {
  id: Scalars['ID'];
  stopTag: UpdateStopTagInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  user: UpdateUserInput;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  line?: Maybe<Line>;
  lineId: Scalars['ID'];
  message: Scalars['String'];
  metadata?: Maybe<MetadataNotification>;
  originId?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  time: Scalars['ISODate'];
  title: Scalars['String'];
  type: NotificationType;
};

export type NotificationFilter = {
  lineId?: InputMaybe<Scalars['ID']>;
};

export type NotificationQueryResponse = {
  __typename?: 'NotificationQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Notification>>;
};

export enum NotificationType {
  Justification = 'JUSTIFICATION',
  LineStop = 'LINE_STOP',
  MachineAlarm = 'MACHINE_ALARM',
  MonitoringStatus = 'MONITORING_STATUS',
  ParamLimit = 'PARAM_LIMIT'
}

export type NotificationTypeFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Order = {
  ordering: Ordering;
  priority: Scalars['Int'];
};

export enum Ordering {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OverviewFilter = {
  date?: InputMaybe<Scalars['ISODate']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
};

export type OverviewLine = {
  __typename?: 'OverviewLine';
  currentShift: OverviewResponse;
  day: OverviewResponse;
  lastShift: OverviewResponse;
  lineCode: Scalars['String'];
  lineId: Scalars['String'];
  month: OverviewResponse;
  previousShift: OverviewResponse;
  status: MachineStatus;
};

export type OverviewResponse = {
  __typename?: 'OverviewResponse';
  lineId?: Maybe<Scalars['ID']>;
  lineName?: Maybe<Scalars['String']>;
  oee: Scalars['Float'];
  production: Scalars['Float'];
  projection: Scalars['Float'];
  status?: Maybe<MachineStatus>;
  workShift?: Maybe<WorkShift>;
};

export type OverviewTimelineEvents = {
  __typename?: 'OverviewTimelineEvents';
  events: Array<TimelineEvent>;
  idealCycleTime?: Maybe<Scalars['Float']>;
  lineId: Scalars['String'];
  thresholds?: Maybe<EventThresholds>;
};

export type Pagination = {
  cursor?: InputMaybe<Scalars['String']>;
  everything?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Parameter = {
  __typename?: 'Parameter';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['ISODate'];
  files?: Maybe<Array<ParameterFile>>;
  id: Scalars['ID'];
  inferiorLimit?: Maybe<Scalars['Float']>;
  machine?: Maybe<Machine>;
  machineId: Scalars['ID'];
  name: Scalars['String'];
  superiorLimit?: Maybe<Scalars['Float']>;
  type: ParameterType;
  unit: Unit;
  updatedAt: Scalars['ISODate'];
  values?: Maybe<Array<ParameterValue>>;
};

export type ParameterFile = {
  __typename?: 'ParameterFile';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISODate'];
  downloadSize: Scalars['Int'];
  id: Scalars['ID'];
  itemId?: Maybe<Scalars['ID']>;
  itemOrType?: Maybe<ItemOrType>;
  mimeType: Scalars['String'];
  parameter?: Maybe<Parameter>;
  parameterId: Scalars['ID'];
  updatedAt: Scalars['ISODate'];
  url: Scalars['String'];
};

export type ParameterFileFilter = {
  active?: InputMaybe<BooleanFilter>;
  downloadSize?: InputMaybe<IntFilter>;
  mimeType?: InputMaybe<StringFilter>;
  parameterId?: InputMaybe<IdFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ParameterFileOrdering = {
  active?: InputMaybe<Order>;
  downloadSize?: InputMaybe<Order>;
  mimeType?: InputMaybe<Order>;
  parameterId?: InputMaybe<Order>;
  url?: InputMaybe<Order>;
};

export type ParameterFileQueryResponse = {
  __typename?: 'ParameterFileQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ParameterFile>>;
};

export type ParameterFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ParameterType>;
  unit?: InputMaybe<Unit>;
};

export type ParameterQueryResponse = {
  __typename?: 'ParameterQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Parameter>>;
};

export enum ParameterType {
  Measurement = 'MEASUREMENT',
  Setpoint = 'SETPOINT'
}

export type ParameterTypeFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type ParameterValue = {
  __typename?: 'ParameterValue';
  aboveSuperiorLimit: Scalars['Boolean'];
  belowInferiorLimit: Scalars['Boolean'];
  inferiorLimit?: Maybe<Scalars['Float']>;
  item?: Maybe<Item>;
  itemType?: Maybe<ItemType>;
  itemTypeId?: Maybe<Scalars['ID']>;
  parameter?: Maybe<Parameter>;
  parameterId: Scalars['ID'];
  superiorLimit?: Maybe<Scalars['Float']>;
  time: Scalars['ISODate'];
  value: Scalars['Float'];
  workShift?: Maybe<WorkShift>;
};

export type ParameterValueChartFilter = {
  endDate: Scalars['ISODate'];
  itemTypeId?: InputMaybe<Scalars['ID']>;
  machineParameter?: InputMaybe<Array<MachineParameter>>;
  maxValue?: InputMaybe<Scalars['Float']>;
  minValue?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['ISODate'];
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type ParameterValueChartQueryResponse = {
  __typename?: 'ParameterValueChartQueryResponse';
  id: Scalars['ID'];
  machine: Scalars['String'];
  name: Scalars['String'];
  unit: Unit;
  values: Array<MachineParameterValue>;
};

export type ParameterValueFilter = {
  aboveSuperiorLimit?: InputMaybe<Scalars['Boolean']>;
  belowInferiorLimit?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  itemTypeId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  parameterId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  type?: InputMaybe<ParameterType>;
  unit?: InputMaybe<Unit>;
  value?: InputMaybe<FloatFilter>;
  workShifts?: InputMaybe<Array<WorkShift>>;
};

export type ParameterValueHistory = {
  __typename?: 'ParameterValueHistory';
  aboveSuperiorLimit: Scalars['Boolean'];
  belowInferiorLimit: Scalars['Boolean'];
  inferiorLimit?: Maybe<Scalars['Float']>;
  itemTypeName?: Maybe<Scalars['String']>;
  lineCode?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  parameterName?: Maybe<Scalars['String']>;
  parameterType?: Maybe<ParameterType>;
  superiorLimit?: Maybe<Scalars['Float']>;
  time: Scalars['ISODate'];
  unit?: Maybe<Unit>;
  value: Scalars['Float'];
  workShift?: Maybe<WorkShift>;
};

export type ParameterValueHistoryQueryResponse = {
  __typename?: 'ParameterValueHistoryQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ParameterValueHistory>>;
};

export type ParameterValueOrdering = {
  aboveSuperiorLimit?: InputMaybe<Order>;
  belowInferiorLimit?: InputMaybe<Order>;
  parameterId?: InputMaybe<Order>;
  value?: InputMaybe<Order>;
};

export type ParameterValueQueryResponse = {
  __typename?: 'ParameterValueQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ParameterValue>>;
};

export enum Period {
  P1Hour = 'P1_HOUR',
  P1Min = 'P1_MIN',
  P8Hour = 'P8_HOUR',
  P10Min = 'P10_MIN',
  P15Min = 'P15_MIN',
  P24Hour = 'P24_HOUR',
  P30Min = 'P30_MIN'
}

export type PeriodAnalysisData = {
  __typename?: 'PeriodAnalysisData';
  fullStatus: FullStatus;
  machineCode: Scalars['String'];
  machineId: Scalars['ID'];
  metric: Metric;
  timeline: Array<TimelineEvent>;
};

export type PeriodAnalysisFilter = {
  endDate: Scalars['ISODate'];
  lineId: Scalars['ID'];
  startDate: Scalars['ISODate'];
  workShift: WorkShift;
};

export type PeriodAnalysisResponse = {
  __typename?: 'PeriodAnalysisResponse';
  data?: Maybe<Array<PeriodAnalysisData>>;
  workshift: WorkShiftTimeLine;
};

export type PieData = {
  __typename?: 'PieData';
  duration: Scalars['Float'];
  status: MachineStatus;
};

export type PossibleProblem = {
  __typename?: 'PossibleProblem';
  loss: Scalars['String'];
  reason: Scalars['String'];
  stop: Scalars['String'];
};

export type PossibleProblemInput = {
  loss: Scalars['String'];
  reason: Scalars['String'];
  stop: Scalars['String'];
};

export enum ProblemCategory {
  Eletric = 'ELETRIC',
  Mechanical = 'MECHANICAL',
  Operational = 'OPERATIONAL',
  Others = 'OTHERS',
  SupplyChain = 'SUPPLY_CHAIN'
}

export type ProductionFilter = {
  endDate: Scalars['ISODate'];
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  period: Period;
  startDate: Scalars['ISODate'];
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type ProductionHistory = {
  __typename?: 'ProductionHistory';
  accumulated?: Maybe<Scalars['Float']>;
  interval?: Maybe<Scalars['ISODate']>;
  lineName?: Maybe<Scalars['String']>;
  machineName?: Maybe<Scalars['String']>;
  production?: Maybe<Scalars['Float']>;
  projection?: Maybe<Scalars['Float']>;
  shift?: Maybe<WorkShift>;
};

export type ProductionHistoryResponse = {
  __typename?: 'ProductionHistoryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ProductionHistory>>;
};

export type ProductionResponse = {
  __typename?: 'ProductionResponse';
  accumulated?: Maybe<Scalars['Float']>;
  day?: Maybe<Scalars['ISODate']>;
  interval?: Maybe<Scalars['String']>;
  production?: Maybe<Scalars['Float']>;
  projection?: Maybe<Scalars['Float']>;
  shift?: Maybe<WorkShift>;
};

export enum ProductionType {
  Machine = 'MACHINE',
  Manual = 'MANUAL',
  Transport = 'TRANSPORT'
}

export type Query = {
  __typename?: 'Query';
  aggregatedScrapBy?: Maybe<ScrapParetoResponse>;
  aggregatedStopTimeBy?: Maybe<StopPareto>;
  alarm?: Maybe<Alarm>;
  alarms?: Maybe<AlarmQueryResponse>;
  application?: Maybe<Application>;
  applications?: Maybe<ApplicationQueryResponse>;
  conveyor?: Maybe<Conveyor>;
  conveyorState?: Maybe<ConveyorState>;
  conveyorStates?: Maybe<ConveyorStateQueryResponse>;
  conveyors?: Maybe<ConveyorQueryResponse>;
  currentStateOfLine?: Maybe<MachineState>;
  currentStateOfMachine?: Maybe<MachineState>;
  cycleTime?: Maybe<Array<CycleTimeResponse>>;
  factories?: Maybe<FactoryQueryResponse>;
  factory?: Maybe<Factory>;
  group?: Maybe<Group>;
  groups?: Maybe<GroupQueryResponse>;
  item: Item;
  itemType?: Maybe<ItemType>;
  itemTypes?: Maybe<ItemTypeQueryResponse>;
  items?: Maybe<ItemQueryResponse>;
  justifiableSmallStop?: Maybe<JustifiableSmallStop>;
  justifiableSmallStops?: Maybe<JustifiableSmallStopQueryResponse>;
  justifiableStop?: Maybe<JustifiableStop>;
  justifiableStops?: Maybe<JustifiableStopQueryResponse>;
  line?: Maybe<Line>;
  lines?: Maybe<LineQueryResponse>;
  machine?: Maybe<Machine>;
  machineStates?: Maybe<MachineStateQueryResponse>;
  machines?: Maybe<MachineQueryResponse>;
  me?: Maybe<Me>;
  notification?: Maybe<Notification>;
  notifications?: Maybe<NotificationQueryResponse>;
  overview?: Maybe<Array<OverviewLine>>;
  parameter?: Maybe<Parameter>;
  parameterFile?: Maybe<ParameterFile>;
  parameterFiles?: Maybe<ParameterFileQueryResponse>;
  parameterValue?: Maybe<ParameterValue>;
  parameterValueChart?: Maybe<Array<ParameterValueChartQueryResponse>>;
  parameterValues?: Maybe<ParameterValueHistoryQueryResponse>;
  parameters?: Maybe<ParameterQueryResponse>;
  periodAnalysisChart: PeriodAnalysisResponse;
  production?: Maybe<Array<ProductionResponse>>;
  productionHistory?: Maybe<ProductionHistoryResponse>;
  randomLine?: Maybe<Line>;
  runtimeOptions?: Maybe<RuntimeOptions>;
  runtimesOptions?: Maybe<RuntimeOptionsQueryResponse>;
  scrap?: Maybe<Scrap>;
  scrapPossibleFailure?: Maybe<ScrapPossibleFailure>;
  scrapPossibleFailures?: Maybe<ScrapPossibleFailureQueryResponse>;
  scraps?: Maybe<ScrapQueryResponse>;
  stopTag?: Maybe<StopTag>;
  stopTags?: Maybe<StopTagQueryResponse>;
  user?: Maybe<User>;
  users?: Maybe<UsersQueryResponse>;
  workshiftAt: Workshift;
  workshifts: Array<Workshift>;
};


export type QueryAggregatedScrapByArgs = {
  filter?: InputMaybe<ScrapByFilter>;
};


export type QueryAggregatedStopTimeByArgs = {
  filter?: InputMaybe<StopTimeByFilter>;
};


export type QueryAlarmArgs = {
  id: Scalars['ID'];
};


export type QueryAlarmsArgs = {
  filter?: InputMaybe<AlarmFilter>;
  orderBy?: InputMaybe<AlarmOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryApplicationArgs = {
  id: Scalars['ID'];
};


export type QueryApplicationsArgs = {
  filter?: InputMaybe<ApplicationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryConveyorArgs = {
  id: Scalars['ID'];
};


export type QueryConveyorStateArgs = {
  timestampAt: Scalars['ISODate'];
};


export type QueryConveyorStatesArgs = {
  filter?: InputMaybe<ConveyorStateFilter>;
  orderBy?: InputMaybe<ConveyorStateOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryConveyorsArgs = {
  filter?: InputMaybe<ConveyorFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCurrentStateOfLineArgs = {
  lineId: Scalars['ID'];
  onlyCurrentShift?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCurrentStateOfMachineArgs = {
  machineId: Scalars['ID'];
  onlyCurrentShift?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCycleTimeArgs = {
  filter?: InputMaybe<IdealCycleTimeChartFilter>;
};


export type QueryFactoriesArgs = {
  filter?: InputMaybe<FactoryFilter>;
  orderBy?: InputMaybe<FactoryOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryFactoryArgs = {
  id: Scalars['ID'];
};


export type QueryGroupArgs = {
  id: Scalars['ID'];
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<GroupFilter>;
  orderBy?: InputMaybe<GroupOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryItemArgs = {
  id: Scalars['ID'];
};


export type QueryItemTypeArgs = {
  id: Scalars['ID'];
};


export type QueryItemTypesArgs = {
  filter?: InputMaybe<ItemTypeFilter>;
  orderBy?: InputMaybe<ItemTypeOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryItemsArgs = {
  filter?: InputMaybe<ItemFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryJustifiableSmallStopArgs = {
  id: Scalars['ID'];
};


export type QueryJustifiableSmallStopsArgs = {
  filter?: InputMaybe<JustifiableSmallStopFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryJustifiableStopArgs = {
  id: Scalars['ID'];
};


export type QueryJustifiableStopsArgs = {
  filter?: InputMaybe<JustifiableStopFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryLineArgs = {
  id: Scalars['ID'];
};


export type QueryLinesArgs = {
  filter?: InputMaybe<LineFilter>;
  orderBy?: InputMaybe<LineOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryMachineArgs = {
  id: Scalars['ID'];
};


export type QueryMachineStatesArgs = {
  filter?: InputMaybe<MachineStateFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryMachinesArgs = {
  filter?: InputMaybe<MachineFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryOverviewArgs = {
  filter?: InputMaybe<OverviewFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryParameterArgs = {
  id: Scalars['ID'];
};


export type QueryParameterFileArgs = {
  id: Scalars['ID'];
};


export type QueryParameterFilesArgs = {
  filter?: InputMaybe<ParameterFileFilter>;
  orderBy?: InputMaybe<ParameterFileOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryParameterValueArgs = {
  parameterId: Scalars['ID'];
  time: Scalars['ISODate'];
};


export type QueryParameterValueChartArgs = {
  filter: ParameterValueChartFilter;
};


export type QueryParameterValuesArgs = {
  filter?: InputMaybe<ParameterValueFilter>;
  orderBy?: InputMaybe<ParameterValueOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryParametersArgs = {
  filter?: InputMaybe<ParameterFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryPeriodAnalysisChartArgs = {
  filter: PeriodAnalysisFilter;
};


export type QueryProductionArgs = {
  filter: ProductionFilter;
};


export type QueryProductionHistoryArgs = {
  filter: ProductionFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryRuntimeOptionsArgs = {
  id: Scalars['ID'];
};


export type QueryRuntimesOptionsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryScrapArgs = {
  id: Scalars['ID'];
};


export type QueryScrapPossibleFailureArgs = {
  id: Scalars['ID'];
};


export type QueryScrapPossibleFailuresArgs = {
  filter?: InputMaybe<ScrapPossibleFailureFilter>;
  orderBy?: InputMaybe<ScrapPossibleFailureOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryScrapsArgs = {
  filter?: InputMaybe<ScrapFilter>;
  orderBy?: InputMaybe<ScrapOrdering>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryStopTagArgs = {
  id: Scalars['ID'];
};


export type QueryStopTagsArgs = {
  filter?: InputMaybe<StopTagFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryWorkshiftAtArgs = {
  time?: InputMaybe<Scalars['ISODate']>;
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  createdAt: Scalars['ISODate'];
  family: Scalars['String'];
  token: Scalars['String'];
  user?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type RefreshTokenInput = {
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type RelationFilter = {
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type RuntimeOptions = {
  __typename?: 'RuntimeOptions';
  active: Scalars['Boolean'];
  eventThresholds?: Maybe<EventThresholds>;
  id: Scalars['ID'];
  machine?: Maybe<Machine>;
  machineId: Scalars['ID'];
  scheduleOptions?: Maybe<ScheduleOptions>;
  updatedAt: Scalars['ISODate'];
};

export type RuntimeOptionsQueryResponse = {
  __typename?: 'RuntimeOptionsQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<RuntimeOptions>>;
};

export type ScheduleOptions = {
  __typename?: 'ScheduleOptions';
  shiftAStartsAt: Scalars['Int'];
  shiftBStartsAt: Scalars['Int'];
  shiftCStartsAt: Scalars['Int'];
};

export type Scrap = {
  __typename?: 'Scrap';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  createdAt: Scalars['ISODate'];
  date: Scalars['ISODate'];
  details?: Maybe<ScrapInformation>;
  id: Scalars['ID'];
  machine?: Maybe<Machine>;
  machineId: Scalars['ID'];
  updatedAt: Scalars['ISODate'];
  workShift: WorkShift;
};

export enum ScrapBy {
  Defect = 'DEFECT',
  Item = 'ITEM',
  Machine = 'MACHINE'
}

export type ScrapByFilter = {
  by?: InputMaybe<ScrapBy>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type ScrapByObject = {
  __typename?: 'ScrapByObject';
  amount?: Maybe<Scalars['Float']>;
  details?: Maybe<Array<Maybe<Details>>>;
  name?: Maybe<Scalars['String']>;
};

export type ScrapFilter = {
  active?: InputMaybe<BooleanFilter>;
  amount?: InputMaybe<FloatFilter>;
  details?: InputMaybe<Scalars['JSON']>;
  detectorGroup?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  generatorGroup?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type ScrapInformation = {
  __typename?: 'ScrapInformation';
  description?: Maybe<Scalars['String']>;
  detectorGroup?: Maybe<Scalars['String']>;
  factory?: Maybe<Scalars['ID']>;
  generatorGroup?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  line?: Maybe<Scalars['ID']>;
  scrapPossibleFailure?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type ScrapOrdering = {
  active?: InputMaybe<Order>;
  amount?: InputMaybe<Order>;
};

export type ScrapParetoResponse = {
  __typename?: 'ScrapParetoResponse';
  by?: Maybe<ScrapBy>;
  data?: Maybe<Array<ScrapByObject>>;
};

export type ScrapPossibleFailure = {
  __typename?: 'ScrapPossibleFailure';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISODate'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISODate'];
};

export type ScrapPossibleFailureFilter = {
  active?: InputMaybe<BooleanFilter>;
  description?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ScrapPossibleFailureOrdering = {
  active?: InputMaybe<Order>;
  description?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
};

export type ScrapPossibleFailureQueryResponse = {
  __typename?: 'ScrapPossibleFailureQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<ScrapPossibleFailure>>;
};

export type ScrapQueryResponse = {
  __typename?: 'ScrapQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<Scrap>>;
};

export enum Sector {
  Assembly = 'ASSEMBLY',
  Finishing = 'FINISHING',
  Formation = 'FORMATION',
  NoSector = 'NO_SECTOR'
}

export type SmallStopJustification = {
  __typename?: 'SmallStopJustification';
  description?: Maybe<Scalars['String']>;
  factory?: Maybe<Scalars['ID']>;
  loss?: Maybe<Scalars['String']>;
  machine?: Maybe<Scalars['ID']>;
  machineCode?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  smallStop?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type StopJustification = {
  __typename?: 'StopJustification';
  description?: Maybe<Scalars['String']>;
  factory?: Maybe<Scalars['ID']>;
  loss?: Maybe<Scalars['String']>;
  machine?: Maybe<Scalars['ID']>;
  machineCode?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  stop?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type StopPareto = {
  __typename?: 'StopPareto';
  by?: Maybe<StopTimeBy>;
  data?: Maybe<Array<StopTimeByObject>>;
};

export type StopTag = {
  __typename?: 'StopTag';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISODate'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  tagType: StopTagType;
  updatedAt: Scalars['ISODate'];
};

export type StopTagFilter = {
  tagType?: InputMaybe<StopTagType>;
};

export type StopTagQueryResponse = {
  __typename?: 'StopTagQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<StopTag>>;
};

export enum StopTagType {
  Category = 'CATEGORY',
  Defect = 'DEFECT',
  Loss = 'LOSS',
  Reason = 'REASON'
}

export type StopTagTypeFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export enum StopTimeBy {
  Loss = 'LOSS',
  Machine = 'MACHINE',
  Reason = 'REASON',
  Stop = 'STOP'
}

export type StopTimeByFilter = {
  by?: InputMaybe<StopTimeBy>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  hideUnjustified?: InputMaybe<Scalars['Boolean']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  workShift?: InputMaybe<Array<WorkShift>>;
};

export type StopTimeByObject = {
  __typename?: 'StopTimeByObject';
  duration?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export enum StringCasing {
  Insensitive = 'INSENSITIVE',
  Sensitive = 'SENSITIVE'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  mode?: InputMaybe<StringCasing>;
  neq?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  capacityTrend: Array<CapacityTrend>;
  conveyorCreatedOrUpdated?: Maybe<Array<Conveyor>>;
  itemTypeCreatedOrUpdated?: Maybe<Array<ItemType>>;
  lineCreated: Line;
  lineUpdated: Line;
  machineCreated: Machine;
  machineCreatedOrUpdated?: Maybe<Array<Machine>>;
  machineDisabled?: Maybe<Array<Machine>>;
  machineStateCreated?: Maybe<Array<MachineState>>;
  machineUpdated: Machine;
  overviewLineStateCreated?: Maybe<Array<OverviewTimelineEvents>>;
};


export type SubscriptionCapacityTrendArgs = {
  lineId: Scalars['ID'];
  overMinutes: Scalars['Int'];
};


export type SubscriptionConveyorCreatedOrUpdatedArgs = {
  filter: ConveyorFilter;
};


export type SubscriptionItemTypeCreatedOrUpdatedArgs = {
  filter: ItemTypeFilter;
};


export type SubscriptionLineUpdatedArgs = {
  id: Scalars['ID'];
};


export type SubscriptionMachineCreatedArgs = {
  lineId: Scalars['ID'];
};


export type SubscriptionMachineCreatedOrUpdatedArgs = {
  lineId: Scalars['ID'];
};


export type SubscriptionMachineDisabledArgs = {
  lineId: Scalars['ID'];
};


export type SubscriptionMachineStateCreatedArgs = {
  filter: MachineStateFilter;
};


export type SubscriptionMachineUpdatedArgs = {
  lineId: Scalars['ID'];
};


export type SubscriptionOverviewLineStateCreatedArgs = {
  factoryId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<Pagination>;
};

export type ThresholdLine = {
  __typename?: 'ThresholdLine';
  normalCycle: Scalars['Float'];
  smallStopCycle: Scalars['Float'];
  stopCycle: Scalars['Float'];
};

export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  delta: Scalars['Float'];
  previousRunDelta?: Maybe<Scalars['Float']>;
  previousStatus?: Maybe<MachineStatus>;
  status: MachineStatus;
  time: Scalars['ISODate'];
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  profile: UserProfile;
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export enum Unit {
  Angle = 'ANGLE',
  AngularSpeed = 'ANGULAR_SPEED',
  Area = 'AREA',
  Current = 'CURRENT',
  Dimentionless = 'DIMENTIONLESS',
  ElectricalResistance = 'ELECTRICAL_RESISTANCE',
  Energy = 'ENERGY',
  Force = 'FORCE',
  Frequency = 'FREQUENCY',
  Length = 'LENGTH',
  LinearSpeed = 'LINEAR_SPEED',
  Mass = 'MASS',
  NoUnit = 'NO_UNIT',
  Power = 'POWER',
  Pressure = 'PRESSURE',
  Temperature = 'TEMPERATURE',
  Time = 'TIME',
  Voltage = 'VOLTAGE',
  Volume = 'VOLUME'
}

export type UnitFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpdateApplicationInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateConveyorInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  handleFrom?: InputMaybe<Scalars['String']>;
  handleTo?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['ID']>;
  targetId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ConveyorType>;
};

export type UpdateConveyorStateInput = {
  conveyorId?: InputMaybe<Scalars['ID']>;
  details?: InputMaybe<Scalars['JSON']>;
  speed?: InputMaybe<Scalars['Float']>;
};

export type UpdateFactoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Sector>;
  workShift?: InputMaybe<WorkShift>;
};

export type UpdateItemInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  hasBeenFinished?: InputMaybe<Scalars['Boolean']>;
  itemTypeId?: InputMaybe<Scalars['ID']>;
};

export type UpdateItemTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLineInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottleneckMachineId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  lastMachineId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newLastMachineAuto?: InputMaybe<Scalars['Boolean']>;
  newLastMachineId?: InputMaybe<Scalars['String']>;
  stopsThreshold?: InputMaybe<Scalars['Float']>;
};

export type UpdateMachineInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  idealCycleTime?: InputMaybe<Scalars['Float']>;
  lastItemTime?: InputMaybe<Scalars['ISODate']>;
  lineId?: InputMaybe<Scalars['ID']>;
  mandatoryJustification?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  normalCycle?: InputMaybe<Scalars['Float']>;
  positionX?: InputMaybe<Scalars['Int']>;
  positionY?: InputMaybe<Scalars['Int']>;
  possibleDefects?: InputMaybe<Array<Scalars['String']>>;
  possibleProblems?: InputMaybe<Array<PossibleProblemInput>>;
  smallStopCycle?: InputMaybe<Scalars['Float']>;
  stopCycle?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Unit>;
};

export type UpdateParameterFileInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  downloadSize?: InputMaybe<Scalars['Int']>;
  mimeType?: InputMaybe<Scalars['String']>;
  parameterId?: InputMaybe<Scalars['ID']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateParameterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  inferiorLimit?: InputMaybe<Scalars['Float']>;
  machineId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  plcAddress?: InputMaybe<Scalars['String']>;
  superiorLimit?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ParameterType>;
  unit?: InputMaybe<Unit>;
};

export type UpdateParameterValueInput = {
  aboveSuperiorLimit?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  belowInferiorLimit?: InputMaybe<Scalars['Boolean']>;
  parameterId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateScrapInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['ISODate']>;
  details?: InputMaybe<CreateScrapInformationInput>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<WorkShift>;
};

export type UpdateScrapPossibleFailureInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateStopTagInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tagType?: InputMaybe<StopTagType>;
};

export type UpdateUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['ID']>>;
  profile?: InputMaybe<UserProfile>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean'];
  createdAt: Scalars['ISODate'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['ID']>;
  hasRead?: Maybe<Array<Notification>>;
  id: Scalars['ID'];
  justifiableStop?: Maybe<Array<JustifiableStop>>;
  lastName: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  profile: UserProfile;
  resetPasswordToken?: Maybe<Scalars['String']>;
  resetPasswordTokenExpiration?: Maybe<Scalars['ISODate']>;
  updatedAt: Scalars['ISODate'];
};

export type UserFilter = {
  email?: InputMaybe<Scalars['String']>;
  hasAccessTo?: InputMaybe<Scalars['ID']>;
};

export enum UserProfile {
  Admin = 'ADMIN',
  Process = 'PROCESS',
  Production = 'PRODUCTION',
  Quality = 'QUALITY',
  Supervisor = 'SUPERVISOR'
}

export type UserProfileFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type UsersQueryResponse = {
  __typename?: 'UsersQueryResponse';
  count?: Maybe<Scalars['Int']>;
  hasNext: Scalars['Boolean'];
  value?: Maybe<Array<User>>;
};

export enum WorkShift {
  ShiftA = 'SHIFT_A',
  ShiftB = 'SHIFT_B',
  ShiftC = 'SHIFT_C'
}

export type WorkShiftFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type WorkShiftTimeLine = {
  __typename?: 'WorkShiftTimeLine';
  duration: Scalars['Int'];
  endingAt: Scalars['ISODate'];
  startingAt: Scalars['ISODate'];
};

export type Workshift = {
  __typename?: 'Workshift';
  duration: Scalars['Int'];
  endingAt: Scalars['ISODate'];
  name: Scalars['String'];
  startingAt: Scalars['ISODate'];
};

export type ApplicationListQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type ApplicationListQuery = { __typename?: 'Query', applications?: { __typename?: 'ApplicationQueryResponse', count?: number | null, value?: Array<{ __typename?: 'Application', id: string, name: string, description?: string | null, secretKey: string, permissions?: Array<string> | null, createdAt: any }> | null } | null };

export type DeleteApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteApplicationMutation = { __typename?: 'Mutation', deleteApplication?: { __typename?: 'Application', id: string } | null };

export type UpdateApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateApplicationMutation = { __typename?: 'Mutation', updateApplication?: { __typename?: 'Application', id: string } | null };

export type RegisterApplicationMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  secretKey: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RegisterApplicationMutation = { __typename?: 'Mutation', createApplication?: { __typename?: 'Application', id: string } | null };

export type PeriodAnalysisChartQueryVariables = Exact<{
  filter: PeriodAnalysisFilter;
}>;


export type PeriodAnalysisChartQuery = { __typename?: 'Query', periodAnalysisChart: { __typename?: 'PeriodAnalysisResponse', data?: Array<{ __typename?: 'PeriodAnalysisData', machineId: string, machineCode: string, metric: { __typename?: 'Metric', capacity: number, production: number, loss: number }, fullStatus: { __typename?: 'FullStatus', stop: number, normal: number, slow: number }, timeline: Array<{ __typename?: 'TimelineEvent', time: any, status: MachineStatus, delta: number, previousStatus?: MachineStatus | null, previousRunDelta?: number | null }> }> | null, workshift: { __typename?: 'WorkShiftTimeLine', duration: number, startingAt: any, endingAt: any } } };

export type CycleTimeQueryVariables = Exact<{
  filter?: InputMaybe<IdealCycleTimeChartFilter>;
}>;


export type CycleTimeQuery = { __typename?: 'Query', cycleTime?: Array<{ __typename?: 'CycleTimeResponse', delta: number, count: number }> | null };

export type LineTitleListQueryVariables = Exact<{ [key: string]: never; }>;


export type LineTitleListQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', value?: Array<{ __typename?: 'Line', id: string, code: string, name: string }> | null } | null };

export type LineDashboardListQueryVariables = Exact<{
  factoryId: Scalars['ID'];
  disabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type LineDashboardListQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', value?: Array<{ __typename?: 'Line', id: string, code: string, name: string, disabled?: boolean | null }> | null } | null };

export type WorkshiftAtQueryVariables = Exact<{
  time?: InputMaybe<Scalars['ISODate']>;
}>;


export type WorkshiftAtQuery = { __typename?: 'Query', workshiftAt: { __typename?: 'Workshift', name: string, duration: number, startingAt: any, endingAt: any } };

export type DashboardQueryVariables = Exact<{
  lineId: Scalars['ID'];
}>;


export type DashboardQuery = { __typename?: 'Query', line?: { __typename: 'Line', id: string, name: string, code: string, description?: string | null, nominalBottleneck?: { __typename?: 'Machine', id: string, idealCycleTime: number, currentState?: { __typename?: 'MachineState', production: number } | null } | null, machines?: Array<{ __typename: 'Machine', id: string, name: string, code: string, description?: string | null, disabled?: boolean | null, maxSpeed?: number | null, lineId: string, positionX?: number | null, positionY?: number | null, lastItemTime?: any | null, idealCycleTime: number, currentRuntimeOptions?: { __typename?: 'RuntimeOptions', eventThresholds?: { __typename?: 'EventThresholds', stopCycle: number, normalCycle: number, smallStopCycle: number } | null } | null, currentState?: { __typename: 'MachineState', time: any, status: MachineStatus, hasChangedStatus?: boolean | null, isInstantBottleneck?: boolean | null, isNominalBottleneck?: boolean | null, isLastMachine?: boolean | null, oee: number, production: number, projection: number, performance: number, availability: number, stopTime: number, stopCount: number, smallStopCount: number, smallStopTime: number, machineId: string, speed: number, meanSpeed: number, delta: number, itemType?: { __typename?: 'ItemType', code: string, name: string } | null } | null }> | null } | null, conveyors?: { __typename?: 'ConveyorQueryResponse', value?: Array<{ __typename?: 'Conveyor', id: string, code: string, type: ConveyorType, handleFrom: string, handleTo: string, origin?: { __typename?: 'Machine', id: string, code: string, currentState?: { __typename?: 'MachineState', status: MachineStatus, speed: number } | null } | null, target?: { __typename?: 'Machine', id: string, code: string } | null }> | null } | null, currentStateOfLine?: { __typename: 'MachineState', time: any, status: MachineStatus, hasChangedStatus?: boolean | null, isInstantBottleneck?: boolean | null, isNominalBottleneck?: boolean | null, isLastMachine?: boolean | null, oee: number, production: number, projection: number, performance: number, availability: number, stopTime: number, stopCount: number, smallStopCount: number, smallStopTime: number, machineId: string, speed: number, meanSpeed: number, delta: number, runDelta: number, previousStatus: MachineStatus, previousRunDelta: number, itemType?: { __typename?: 'ItemType', code: string, name: string } | null, machine?: { __typename?: 'Machine', idealCycleTime: number, currentRuntimeOptions?: { __typename?: 'RuntimeOptions', eventThresholds?: { __typename?: 'EventThresholds', stopCycle: number, smallStopCycle: number, normalCycle: number } | null } | null } | null } | null };

export type TimelineEventSubscriptionVariables = Exact<{
  lineId: Scalars['ID'];
}>;


export type TimelineEventSubscription = { __typename?: 'Subscription', machineStateCreated?: Array<{ __typename?: 'MachineState', delta: number, status: MachineStatus, time: any }> | null };

export type PossibleFailuresQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type PossibleFailuresQuery = { __typename?: 'Query', scrapPossibleFailures?: { __typename?: 'ScrapPossibleFailureQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'ScrapPossibleFailure', id: string, name: string, description?: string | null, createdAt: any }> | null } | null };

export type RegisterDefectMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type RegisterDefectMutation = { __typename?: 'Mutation', createScrapPossibleFailure?: { __typename?: 'ScrapPossibleFailure', id: string } | null };

export type UpdateDefectMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type UpdateDefectMutation = { __typename?: 'Mutation', updateScrapPossibleFailure?: { __typename?: 'ScrapPossibleFailure', id: string, name: string, description?: string | null } | null };

export type DeleteDefectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDefectMutation = { __typename?: 'Mutation', deleteScrapPossibleFailure?: { __typename?: 'ScrapPossibleFailure', name: string } | null };

export type FactoriesNameQueryVariables = Exact<{ [key: string]: never; }>;


export type FactoriesNameQuery = { __typename?: 'Query', factories?: { __typename?: 'FactoryQueryResponse', value?: Array<{ __typename?: 'Factory', id: string, code: string, name: string, lines?: Array<{ __typename?: 'Line', id: string, name: string, disabled?: boolean | null }> | null }> | null } | null };

export type FactoriesQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type FactoriesQuery = { __typename?: 'Query', factories?: { __typename?: 'FactoryQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Factory', id: string, code: string, name: string, timezone: string, createdAt: any }> | null } | null };

export type CreateFactoryMutationVariables = Exact<{
  name: Scalars['String'];
  code: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type CreateFactoryMutation = { __typename?: 'Mutation', createFactory?: { __typename?: 'Factory', name: string, code: string, timezone: string } | null };

export type UpdateFactoryMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  code: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type UpdateFactoryMutation = { __typename?: 'Mutation', updateFactory?: { __typename?: 'Factory', name: string, code: string, timezone: string } | null };

export type DeleteFactoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFactoryMutation = { __typename?: 'Mutation', deleteFactory?: { __typename?: 'Factory', id: string } | null };

export type GroupListQueryVariables = Exact<{
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GroupListQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupQueryResponse', count?: number | null, value?: Array<{ __typename?: 'Group', id: string, name: string, sector: Sector, workShift: WorkShift, line?: { __typename?: 'Line', id: string, code: string } | null, factory?: { __typename?: 'Factory', id: string, name: string } | null }> | null } | null };

export type RegisterGroupMutationVariables = Exact<{
  name: Scalars['String'];
  factoryId: Scalars['ID'];
  lineId?: InputMaybe<Scalars['ID']>;
  sector: Sector;
  workShift: WorkShift;
}>;


export type RegisterGroupMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'Group', id: string } | null };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  sector?: InputMaybe<Sector>;
  workShift?: InputMaybe<WorkShift>;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'Group', id: string } | null };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup?: { __typename?: 'Group', id: string } | null };

export type AllGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupQueryResponse', value?: Array<{ __typename?: 'Group', id: string, name: string, lineId?: string | null, line?: { __typename?: 'Line', id: string, name: string } | null }> | null } | null };

export type GetInfoOfDetectorGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetInfoOfDetectorGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, lineId?: string | null, workShift: WorkShift, line?: { __typename?: 'Line', id: string, name: string } | null } | null };

export type ItemsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type ItemsQuery = { __typename?: 'Query', itemTypes?: { __typename?: 'ItemTypeQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'ItemType', id: string, name: string, code: string, description?: string | null, createdAt: any }> | null } | null };

export type RegisterItemMutationVariables = Exact<{
  name: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
}>;


export type RegisterItemMutation = { __typename?: 'Mutation', createItemType: { __typename?: 'ItemType', name: string, code: string, description?: string | null } };

export type UpdateItemMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateItemMutation = { __typename?: 'Mutation', updateItemType: { __typename?: 'ItemType', name: string, code: string, description?: string | null } };

export type DeleteItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteItemMutation = { __typename?: 'Mutation', deleteItemType: { __typename?: 'ItemType', id: string, name: string } };

export type JustifiableStopsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  affect?: InputMaybe<Scalars['Boolean']>;
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  stopTag?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  reasonTag?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  lossTag?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  states?: InputMaybe<Array<JustificationState> | JustificationState>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
}>;


export type JustifiableStopsQuery = { __typename?: 'Query', justifiableStops?: { __typename?: 'JustifiableStopQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'JustifiableStop', id: string, affectAvailability: boolean, state: JustificationState, workShift?: WorkShift | null, startedAt: any, endedAt?: any | null, line?: { __typename?: 'Line', id: string, code: string, factory?: { __typename?: 'Factory', id: string, code: string } | null } | null, machine?: { __typename?: 'Machine', code: string } | null, justification?: { __typename?: 'StopJustification', stop?: string | null, loss?: string | null, reason?: string | null, description?: string | null, user?: string | null, machine?: string | null, machineCode?: string | null } | null }> | null } | null };

export type AggregatedStopTimeByQueryVariables = Exact<{
  filter?: InputMaybe<StopTimeByFilter>;
}>;


export type AggregatedStopTimeByQuery = { __typename?: 'Query', aggregatedStopTimeBy?: { __typename?: 'StopPareto', by?: StopTimeBy | null, data?: Array<{ __typename?: 'StopTimeByObject', name?: string | null, duration?: number | null }> | null } | null };

export type MachinesQueryVariables = Exact<{
  lineId?: InputMaybe<Scalars['ID']>;
}>;


export type MachinesQuery = { __typename?: 'Query', machines?: { __typename?: 'MachineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Machine', id: string, name: string, code: string, positionX?: number | null, positionY?: number | null, possibleProblems: Array<{ __typename?: 'PossibleProblem', stop: string, reason: string, loss: string }> }> | null } | null };

export type JustifyStopMutationVariables = Exact<{
  affectAvailability: Scalars['Boolean'];
  id: Scalars['ID'];
  user: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  machine: Scalars['ID'];
  reasonTag: Scalars['String'];
  lossTag: Scalars['String'];
  stopTag: Scalars['String'];
}>;


export type JustifyStopMutation = { __typename?: 'Mutation', justifyStop?: { __typename?: 'JustifiableStop', id: string, lineId: string } | null };

export type SpecificNotificationStopQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SpecificNotificationStopQuery = { __typename?: 'Query', justifiableStop?: { __typename?: 'JustifiableStop', id: string, lineId: string, startedAt: any, endedAt?: any | null, state: JustificationState, line?: { __typename?: 'Line', code: string } | null, machine?: { __typename?: 'Machine', id: string, code: string } | null, justification?: { __typename?: 'StopJustification', stop?: string | null, loss?: string | null, reason?: string | null, description?: string | null, user?: string | null, machine?: string | null, machineCode?: string | null } | null } | null };

export type LastMachineIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LastMachineIdQuery = { __typename?: 'Query', line?: { __typename?: 'Line', lastMachineId?: string | null } | null };

export type RegisterLineMutationVariables = Exact<{
  name: Scalars['String'];
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  stopsThreshold: Scalars['Float'];
  factoryId: Scalars['ID'];
}>;


export type RegisterLineMutation = { __typename?: 'Mutation', createLine?: { __typename?: 'Line', id: string } | null };

export type LineListQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  factoryId?: InputMaybe<Scalars['ID']>;
}>;


export type LineListQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Line', id: string, name: string, code: string, description?: string | null, autoLastMachine?: boolean | null, newLastMachineAuto?: boolean | null, autoBottleneckMachine?: boolean | null, stopsThreshold: number, disabled?: boolean | null, createdAt: any, factory?: { __typename?: 'Factory', id: string, name: string } | null, machines?: Array<{ __typename?: 'Machine', id: string, name: string }> | null, lastMachine?: { __typename?: 'Machine', id: string, name: string } | null, newLastMachine?: { __typename?: 'Machine', id: string, name: string } | null, nominalBottleneck?: { __typename?: 'Machine', id: string, name: string } | null }> | null } | null };

export type UpdateLineMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  stopsThreshold: Scalars['Float'];
  factoryId?: InputMaybe<Scalars['ID']>;
  lastMachineId?: InputMaybe<Scalars['String']>;
  newLastMachineId?: InputMaybe<Scalars['String']>;
  newLastMachineAuto?: InputMaybe<Scalars['Boolean']>;
  bottleneckMachineId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateLineMutation = { __typename?: 'Mutation', updateLine?: { __typename?: 'Line', id: string, name: string, description?: string | null, disabled?: boolean | null } | null };

export type DisableLineMutationVariables = Exact<{
  id: Scalars['ID'];
  disabled: Scalars['Boolean'];
}>;


export type DisableLineMutation = { __typename?: 'Mutation', disableLine?: { __typename?: 'Line', id: string, name: string } | null };

export type DeleteLineMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLineMutation = { __typename?: 'Mutation', deleteLine?: { __typename?: 'Line', name: string } | null };

export type LineHistoryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  lineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
}>;


export type LineHistoryQuery = { __typename?: 'Query', machineStates?: { __typename?: 'MachineStateQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'MachineState', oee: number, performance: number, availability: number, production: number, stopTime: number, stopCount: number, workShift: WorkShift, time: any, lossHP?: number | null, lossProduction?: number | null, machine?: { __typename?: 'Machine', id: string, line?: { __typename?: 'Line', id: string, code: string } | null } | null }> | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResponse', token: string, profile: UserProfile, refreshToken: string, firstName: string, lastName: string } | null };

export type LossesQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type LossesQuery = { __typename?: 'Query', stopTags?: { __typename?: 'StopTagQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'StopTag', id: string, name: string, description?: string | null, createdAt: any }> | null } | null };

export type RegisterLossMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type RegisterLossMutation = { __typename?: 'Mutation', createStopTag?: { __typename?: 'StopTag', id: string, name: string, description?: string | null } | null };

export type UpdateLossMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type UpdateLossMutation = { __typename?: 'Mutation', updateStopTag?: { __typename?: 'StopTag', id: string, name: string, description?: string | null } | null };

export type DeleteLossMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLossMutation = { __typename?: 'Mutation', deleteStopTag?: { __typename?: 'StopTag', id: string, name: string } | null };

export type MachineListQueryVariables = Exact<{
  offset: Scalars['Int'];
  lineId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
}>;


export type MachineListQuery = { __typename?: 'Query', machines?: { __typename?: 'MachineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Machine', id: string, name: string, code: string, unit: Unit, description?: string | null, disabled?: boolean | null, idealCycleTime: number, createdAt: any, positionX?: number | null, positionY?: number | null, possibleDefects?: Array<string> | null, mandatoryJustification: boolean, line?: { __typename?: 'Line', id: string, code: string, lastMachineId?: string | null } | null, runtimeOptions?: Array<{ __typename?: 'RuntimeOptions', eventThresholds?: { __typename?: 'EventThresholds', normalCycle: number, smallStopCycle: number, stopCycle: number } | null }> | null, possibleProblems: Array<{ __typename?: 'PossibleProblem', stop: string, loss: string, reason: string }> }> | null } | null };

export type DeleteMachineMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMachineMutation = { __typename?: 'Mutation', deleteMachine?: { __typename?: 'Machine', name: string } | null };

export type DisableMachineMutationVariables = Exact<{
  id: Scalars['ID'];
  active: Scalars['Boolean'];
}>;


export type DisableMachineMutation = { __typename?: 'Mutation', disableMachine?: { __typename?: 'Machine', id: string, name: string } | null };

export type RegisterMachineMutationVariables = Exact<{
  lineId: Scalars['ID'];
  name: Scalars['String'];
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  idealCycleTime: Scalars['Float'];
  unit: Unit;
  positionX?: InputMaybe<Scalars['Int']>;
  positionY?: InputMaybe<Scalars['Int']>;
  normalCycle: Scalars['Float'];
  smallStopCycle: Scalars['Float'];
  stopCycle: Scalars['Float'];
  possibleProblems: Array<PossibleProblemInput> | PossibleProblemInput;
  possibleDefects?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  mandatoryJustification: Scalars['Boolean'];
}>;


export type RegisterMachineMutation = { __typename?: 'Mutation', createMachine?: { __typename?: 'Machine', id: string, name: string } | null };

export type UpdateMachineMutationVariables = Exact<{
  id: Scalars['ID'];
  lineId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  idealCycleTime?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Unit>;
  positionX?: InputMaybe<Scalars['Int']>;
  positionY?: InputMaybe<Scalars['Int']>;
  normalCycle?: InputMaybe<Scalars['Float']>;
  smallStopCycle?: InputMaybe<Scalars['Float']>;
  stopCycle?: InputMaybe<Scalars['Float']>;
  possibleProblems?: InputMaybe<Array<PossibleProblemInput> | PossibleProblemInput>;
  possibleDefects?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  mandatoryJustification?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateMachineMutation = { __typename?: 'Mutation', updateMachine?: { __typename?: 'Machine', id: string, name: string } | null };

export type MachineHistoryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
}>;


export type MachineHistoryQuery = { __typename?: 'Query', machineStates?: { __typename?: 'MachineStateQueryResponse', count?: number | null, value?: Array<{ __typename?: 'MachineState', workShift: WorkShift, oee: number, stopCount: number, stopTime: number, time: any, production: number, amount: number, status: MachineStatus, machine?: { __typename?: 'Machine', idealCycleTime: number, name: string, code: string, id: string, mandatoryJustification: boolean, line?: { __typename?: 'Line', name: string, code: string, id: string } | null } | null }> | null } | null };

export type AllMachinesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMachinesQuery = { __typename?: 'Query', machines?: { __typename?: 'MachineQueryResponse', value?: Array<{ __typename?: 'Machine', id: string, code: string }> | null } | null };

export type NotificationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Notification', id: string, lineId: string, title: string, originId?: string | null, scope: string, message: string, time: any, type: NotificationType, metadata?: { __typename?: 'MetadataNotification', duration?: number | null } | null }> | null } | null };

export type OeeChartQueryVariables = Exact<{
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  onlyLast: Scalars['Boolean'];
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
}>;


export type OeeChartQuery = { __typename?: 'Query', machineStates?: { __typename?: 'MachineStateQueryResponse', count?: number | null, value?: Array<{ __typename?: 'MachineState', workShift: WorkShift, time: any, oee: number, performance: number, availability: number }> | null } | null };

export type OverviewQueryVariables = Exact<{
  factoryId: Scalars['ID'];
}>;


export type OverviewQuery = { __typename?: 'Query', overview?: Array<{ __typename?: 'OverviewLine', lineId: string, lineCode: string, status: MachineStatus, currentShift: { __typename?: 'OverviewResponse', oee: number, production: number, projection: number }, previousShift: { __typename?: 'OverviewResponse', oee: number, production: number, projection: number }, lastShift: { __typename?: 'OverviewResponse', oee: number, production: number, projection: number }, day: { __typename?: 'OverviewResponse', oee: number, production: number, projection: number }, month: { __typename?: 'OverviewResponse', oee: number, production: number, projection: number } }> | null };

export type TimelineOverviewSubscriptionVariables = Exact<{
  factoryId: Scalars['ID'];
  offset: Scalars['Int'];
}>;


export type TimelineOverviewSubscription = { __typename?: 'Subscription', overviewLineStateCreated?: Array<{ __typename?: 'OverviewTimelineEvents', lineId: string, idealCycleTime?: number | null, thresholds?: { __typename?: 'EventThresholds', normalCycle: number, stopCycle: number } | null, events: Array<{ __typename?: 'TimelineEvent', status: MachineStatus, delta: number, time: any }> }> | null };

export type OverviewLinesQueryVariables = Exact<{
  factoryId: Scalars['ID'];
  offset: Scalars['Int'];
}>;


export type OverviewLinesQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', count?: number | null, value?: Array<{ __typename?: 'Line', id: string, name: string, code: string }> | null } | null };

export type ParameterValueListQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  itemTypeId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ParameterType>;
  unit?: InputMaybe<Unit>;
  workShifts?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  aboveSuperiorLimit?: InputMaybe<Scalars['Boolean']>;
  belowInferiorLimit?: InputMaybe<Scalars['Boolean']>;
}>;


export type ParameterValueListQuery = { __typename?: 'Query', parameterValues?: { __typename?: 'ParameterValueHistoryQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'ParameterValueHistory', value: number, unit?: Unit | null, time: any, workShift?: WorkShift | null, superiorLimit?: number | null, inferiorLimit?: number | null, aboveSuperiorLimit: boolean, belowInferiorLimit: boolean, parameterName?: string | null, parameterType?: ParameterType | null, machineName?: string | null, lineCode?: string | null, itemTypeName?: string | null }> | null } | null };

export type ParameterNamesQueryVariables = Exact<{
  machineId?: InputMaybe<Scalars['ID']>;
}>;


export type ParameterNamesQuery = { __typename?: 'Query', parameters?: { __typename?: 'ParameterQueryResponse', value?: Array<{ __typename?: 'Parameter', id: string, code: string, name: string }> | null } | null };

export type ParameterListQueryVariables = Exact<{
  offset: Scalars['Int'];
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
}>;


export type ParameterListQuery = { __typename?: 'Query', parameters?: { __typename?: 'ParameterQueryResponse', count?: number | null, value?: Array<{ __typename?: 'Parameter', createdAt: any, id: string, code: string, name: string, unit: Unit, type: ParameterType, superiorLimit?: number | null, inferiorLimit?: number | null, machine?: { __typename?: 'Machine', id: string, code: string, name: string, line?: { __typename?: 'Line', id: string, code: string } | null } | null }> | null } | null };

export type RegisterParameterMutationVariables = Exact<{
  code: Scalars['String'];
  name: Scalars['String'];
  unit: Unit;
  machineId: Scalars['ID'];
  superiorLimit: Scalars['Float'];
  inferiorLimit: Scalars['Float'];
  type: ParameterType;
}>;


export type RegisterParameterMutation = { __typename?: 'Mutation', createParameter?: { __typename?: 'Parameter', id: string } | null };

export type DeleteParameterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteParameterMutation = { __typename?: 'Mutation', deleteParameter?: { __typename?: 'Parameter', name: string } | null };

export type UpdateParameterMutationVariables = Exact<{
  id: Scalars['ID'];
  code: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit>;
  machineId?: InputMaybe<Scalars['ID']>;
  superiorLimit?: InputMaybe<Scalars['Float']>;
  inferiorLimit?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ParameterType>;
}>;


export type UpdateParameterMutation = { __typename?: 'Mutation', updateParameter?: { __typename?: 'Parameter', id: string } | null };

export type ParameterValueChartQueryVariables = Exact<{
  startDate: Scalars['ISODate'];
  endDate: Scalars['ISODate'];
  workShifts?: InputMaybe<Array<WorkShift> | WorkShift>;
  machineParameter?: InputMaybe<Array<MachineParameter> | MachineParameter>;
  itemTypeId?: InputMaybe<Scalars['ID']>;
  minValue?: InputMaybe<Scalars['Float']>;
  maxValue?: InputMaybe<Scalars['Float']>;
}>;


export type ParameterValueChartQuery = { __typename?: 'Query', parameterValueChart?: Array<{ __typename?: 'ParameterValueChartQueryResponse', unit: Unit, machine: string, id: string, name: string, values: Array<{ __typename?: 'MachineParameterValue', date: any, value: number }> }> | null };

export type ProductionChartQueryVariables = Exact<{
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['ISODate'];
  endDate: Scalars['ISODate'];
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  period: Period;
}>;


export type ProductionChartQuery = { __typename?: 'Query', production?: Array<{ __typename?: 'ProductionResponse', interval?: string | null, day?: any | null, accumulated?: number | null, projection?: number | null, production?: number | null }> | null };

export type ProductionCycleHistoryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
}>;


export type ProductionCycleHistoryQuery = { __typename?: 'Query', machineStates?: { __typename?: 'MachineStateQueryResponse', count?: number | null, value?: Array<{ __typename?: 'MachineState', machineId: string, production: number, projection: number, amount: number, status: MachineStatus, workShift: WorkShift, time: any, machine?: { __typename?: 'Machine', name: string, code: string, id: string, line?: { __typename?: 'Line', name: string, code: string, id: string } | null } | null }> | null } | null };

export type ProductionHistoryQueryVariables = Exact<{
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['ISODate'];
  endDate: Scalars['ISODate'];
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  period: Period;
}>;


export type ProductionHistoryQuery = { __typename?: 'Query', productionHistory?: { __typename?: 'ProductionHistoryResponse', count?: number | null, value?: Array<{ __typename?: 'ProductionHistory', interval?: any | null, lineName?: string | null, machineName?: string | null, accumulated?: number | null, shift?: WorkShift | null, projection?: number | null, production?: number | null }> | null } | null };

export type ProductionRateMaxCapacityQueryVariables = Exact<{
  lineId: Scalars['ID'];
}>;


export type ProductionRateMaxCapacityQuery = { __typename?: 'Query', line?: { __typename?: 'Line', nominalBottleneck?: { __typename?: 'Machine', name: string, maxSpeed?: number | null } | null } | null };

export type CapacityTrendSubscriptionVariables = Exact<{
  lineId: Scalars['ID'];
  overMinutes: Scalars['Int'];
}>;


export type CapacityTrendSubscription = { __typename?: 'Subscription', capacityTrend: Array<{ __typename?: 'CapacityTrend', machineId: string, machineName: string, overMinutes: number, capacityBefore: number, capacityAfter: number, capacityLimit: number }> };

export type ReasonsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type ReasonsQuery = { __typename?: 'Query', stopTags?: { __typename?: 'StopTagQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'StopTag', id: string, name: string, description?: string | null, createdAt: any }> | null } | null };

export type RegisterReasonMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type RegisterReasonMutation = { __typename?: 'Mutation', createStopTag?: { __typename?: 'StopTag', id: string, name: string, description?: string | null } | null };

export type UpdateReasonMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type UpdateReasonMutation = { __typename?: 'Mutation', updateStopTag?: { __typename?: 'StopTag', id: string, name: string, description?: string | null } | null };

export type DeleteReasonMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReasonMutation = { __typename?: 'Mutation', deleteStopTag?: { __typename?: 'StopTag', id: string, name: string } | null };

export type RecoverPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RecoverPasswordMutation = { __typename?: 'Mutation', recoverPassword?: boolean | null };

export type RefreshMutationVariables = Exact<{
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
}>;


export type RefreshMutation = { __typename?: 'Mutation', refresh?: { __typename?: 'TokenResponse', token: string, refreshToken: string, profile: UserProfile } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type ScrapFactoriesNameQueryVariables = Exact<{ [key: string]: never; }>;


export type ScrapFactoriesNameQuery = { __typename?: 'Query', factories?: { __typename?: 'FactoryQueryResponse', value?: Array<{ __typename?: 'Factory', id: string, code: string, name: string, lines?: Array<{ __typename?: 'Line', disabled?: boolean | null }> | null }> | null } | null };

export type LinesNamesQueryVariables = Exact<{
  factoryId: Scalars['ID'];
}>;


export type LinesNamesQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Line', id: string, name: string, code: string }> | null } | null };

export type AggregatedScrapByQueryVariables = Exact<{
  filter?: InputMaybe<ScrapByFilter>;
}>;


export type AggregatedScrapByQuery = { __typename?: 'Query', aggregatedScrapBy?: { __typename?: 'ScrapParetoResponse', by?: ScrapBy | null, data?: Array<{ __typename?: 'ScrapByObject', name?: string | null, amount?: number | null, details?: Array<{ __typename?: 'Details', name?: string | null, amount?: number | null } | null> | null }> | null } | null };

export type LinesFromFactoryQueryVariables = Exact<{
  factoryId?: InputMaybe<Scalars['ID']>;
}>;


export type LinesFromFactoryQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Line', id: string, name: string, code: string, factory?: { __typename?: 'Factory', id: string, name: string } | null }> | null } | null };

export type LinesFromFactoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type LinesFromFactoriesQuery = { __typename?: 'Query', lines?: { __typename?: 'LineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Line', id: string, name: string, code: string, factory?: { __typename?: 'Factory', id: string, name: string } | null }> | null } | null };

export type MachinesFromLineQueryVariables = Exact<{
  lineId: Scalars['ID'];
}>;


export type MachinesFromLineQuery = { __typename?: 'Query', machines?: { __typename?: 'MachineQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Machine', id: string, name: string, code: string, mandatoryJustification: boolean, possibleDefects?: Array<string> | null }> | null } | null };

export type ScrapUserNameQueryVariables = Exact<{
  idLine: Scalars['ID'];
}>;


export type ScrapUserNameQuery = { __typename?: 'Query', line?: { __typename?: 'Line', id: string, hasAccess?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> | null } | null };

export type ScrapItemTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type ScrapItemTypeQuery = { __typename?: 'Query', itemTypes?: { __typename?: 'ItemTypeQueryResponse', value?: Array<{ __typename?: 'ItemType', id: string, name: string }> | null } | null };

export type ScrapDefectNameQueryVariables = Exact<{ [key: string]: never; }>;


export type ScrapDefectNameQuery = { __typename?: 'Query', scrapPossibleFailures?: { __typename?: 'ScrapPossibleFailureQueryResponse', value?: Array<{ __typename?: 'ScrapPossibleFailure', id: string, name: string }> | null } | null };

export type RegisterScrapMutationVariables = Exact<{
  amount: Scalars['Float'];
  machineId: Scalars['ID'];
  details?: InputMaybe<CreateScrapInformationInput>;
  workShift: WorkShift;
  date: Scalars['ISODate'];
}>;


export type RegisterScrapMutation = { __typename?: 'Mutation', createScrap?: { __typename?: 'Scrap', id: string } | null };

export type DeleteScrapMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteScrapMutation = { __typename?: 'Mutation', deleteScrap?: { __typename?: 'Scrap', id: string } | null };

export type UpdateScrapMutationVariables = Exact<{
  id: Scalars['ID'];
  amount?: InputMaybe<Scalars['Float']>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<WorkShift>;
  date?: InputMaybe<Scalars['ISODate']>;
  details?: InputMaybe<CreateScrapInformationInput>;
}>;


export type UpdateScrapMutation = { __typename?: 'Mutation', updateScrap?: { __typename?: 'Scrap', id: string } | null };

export type ScrapQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ScrapQuery = { __typename?: 'Query', scrap?: { __typename?: 'Scrap', id: string, amount: number, workShift: WorkShift, date: any, machine?: { __typename?: 'Machine', id: string, code: string, line?: { __typename?: 'Line', id: string, code: string, factory?: { __typename?: 'Factory', id: string, name: string } | null } | null } | null, details?: { __typename?: 'ScrapInformation', item?: string | null, scrapPossibleFailure?: string | null, description?: string | null, user?: string | null, detectorGroup?: string | null, generatorGroup?: string | null } | null } | null };

export type ScrapsQueryVariables = Exact<{
  factoryId?: InputMaybe<Scalars['ID']>;
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  item?: InputMaybe<Scalars['String']>;
  generatorGroup?: InputMaybe<Scalars['String']>;
  detectorGroup?: InputMaybe<Scalars['String']>;
}>;


export type ScrapsQuery = { __typename?: 'Query', scraps?: { __typename?: 'ScrapQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'Scrap', id: string, amount: number, machineId: string, workShift: WorkShift, date: any, machine?: { __typename?: 'Machine', id: string, code: string, line?: { __typename?: 'Line', id: string, code: string, factory?: { __typename?: 'Factory', id: string, name: string } | null } | null } | null, details?: { __typename?: 'ScrapInformation', factory?: string | null, line?: string | null, item?: string | null, scrapPossibleFailure?: string | null, description?: string | null, user?: string | null, detectorGroup?: string | null, generatorGroup?: string | null } | null }> | null } | null };

export type GroupsQueryVariables = Exact<{
  lineId?: InputMaybe<Scalars['ID']>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupQueryResponse', value?: Array<{ __typename?: 'Group', id: string, name: string, sector: Sector, workShift: WorkShift, lineId?: string | null, line?: { __typename?: 'Line', name: string } | null }> | null } | null };

export type SmallStopsHistoryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  lineId?: InputMaybe<Scalars['ID']>;
  machineId?: InputMaybe<Scalars['ID']>;
  workShift?: InputMaybe<Array<WorkShift> | WorkShift>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['ISODate']>;
}>;


export type SmallStopsHistoryQuery = { __typename?: 'Query', justifiableSmallStops?: { __typename?: 'JustifiableSmallStopQueryResponse', count?: number | null, value?: Array<{ __typename?: 'JustifiableSmallStop', id: string, state: JustificationState, machineId: string, startedAt: any, endedAt?: any | null, workShift?: WorkShift | null, machine?: { __typename?: 'Machine', lineId: string, code: string, line?: { __typename?: 'Line', id: string, code: string, name: string } | null } | null }> | null } | null };

export type MachineListFromLineQueryVariables = Exact<{
  lineId: Scalars['ID'];
}>;


export type MachineListFromLineQuery = { __typename?: 'Query', machines?: { __typename?: 'MachineQueryResponse', value?: Array<{ __typename?: 'Machine', name: string, id: string, code: string, line?: { __typename?: 'Line', id: string, name: string, code: string } | null }> | null } | null };

export type StopTagsQueryVariables = Exact<{
  offset: Scalars['Int'];
  tagType: StopTagType;
  limit: Scalars['Int'];
}>;


export type StopTagsQuery = { __typename?: 'Query', stopTags?: { __typename?: 'StopTagQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'StopTag', id: string, name: string, description?: string | null, tagType: StopTagType, createdAt: any }> | null } | null };

export type AllStopTagsQueryVariables = Exact<{
  tagType: StopTagType;
}>;


export type AllStopTagsQuery = { __typename?: 'Query', stopTags?: { __typename?: 'StopTagQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'StopTag', id: string, name: string, description?: string | null }> | null } | null };

export type RegisterStopMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  tagType: StopTagType;
}>;


export type RegisterStopMutation = { __typename?: 'Mutation', createStopTag?: { __typename?: 'StopTag', id: string } | null };

export type UpdateStopMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type UpdateStopMutation = { __typename?: 'Mutation', updateStopTag?: { __typename?: 'StopTag', id: string, name: string, description?: string | null } | null };

export type DeleteStopMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStopMutation = { __typename?: 'Mutation', deleteStopTag?: { __typename?: 'StopTag', name: string } | null };

export type RegisterUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  permissions: Array<Scalars['ID']> | Scalars['ID'];
  profile: UserProfile;
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string } | null };

export type UserListQueryVariables = Exact<{
  offset: Scalars['Int'];
  hasAcessTo: Scalars['ID'];
  limit: Scalars['Int'];
}>;


export type UserListQuery = { __typename?: 'Query', users?: { __typename?: 'UsersQueryResponse', count?: number | null, hasNext: boolean, value?: Array<{ __typename?: 'User', id: string, profile: UserProfile, email: string, firstName: string, lastName: string, permissions?: Array<string> | null, active: boolean, groupId?: string | null }> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<UserProfile>;
  permissions?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'User', id: string } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, email: string, profile: UserProfile, permissions?: Array<string> | null, firstName: string, lastName: string, groupId?: string | null, group?: { __typename?: 'Group', name: string, sector: Sector } | null } | null };


export const ApplicationListDocument = gql`
    query ApplicationList($offset: Int!, $limit: Int!) {
  applications(
    filter: {showDeleted: false}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      id
      name
      description
      secretKey
      permissions
      createdAt
    }
    count
  }
}
    `;

export function useApplicationListQuery(options: Omit<Urql.UseQueryArgs<ApplicationListQueryVariables>, 'query'>) {
  return Urql.useQuery<ApplicationListQuery, ApplicationListQueryVariables>({ query: ApplicationListDocument, ...options });
};
export const DeleteApplicationDocument = gql`
    mutation DeleteApplication($id: ID!) {
  deleteApplication(id: $id) {
    id
  }
}
    `;

export function useDeleteApplicationMutation() {
  return Urql.useMutation<DeleteApplicationMutation, DeleteApplicationMutationVariables>(DeleteApplicationDocument);
};
export const UpdateApplicationDocument = gql`
    mutation UpdateApplication($id: ID!, $name: String, $description: String, $permissions: [String!]) {
  updateApplication(
    id: $id
    application: {name: $name, description: $description, permissions: $permissions}
  ) {
    id
  }
}
    `;

export function useUpdateApplicationMutation() {
  return Urql.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument);
};
export const RegisterApplicationDocument = gql`
    mutation RegisterApplication($name: String!, $description: String, $secretKey: String!, $permissions: [String!]) {
  createApplication(
    application: {name: $name, description: $description, secretKey: $secretKey, permissions: $permissions}
  ) {
    id
  }
}
    `;

export function useRegisterApplicationMutation() {
  return Urql.useMutation<RegisterApplicationMutation, RegisterApplicationMutationVariables>(RegisterApplicationDocument);
};
export const PeriodAnalysisChartDocument = gql`
    query PeriodAnalysisChart($filter: PeriodAnalysisFilter!) {
  periodAnalysisChart(filter: $filter) {
    data {
      machineId
      machineCode
      metric {
        capacity
        production
        loss
      }
      fullStatus {
        stop
        normal
        slow
      }
      timeline {
        time
        status
        delta
        previousStatus
        previousRunDelta
      }
    }
    workshift {
      duration
      startingAt
      endingAt
    }
  }
}
    `;

export function usePeriodAnalysisChartQuery(options: Omit<Urql.UseQueryArgs<PeriodAnalysisChartQueryVariables>, 'query'>) {
  return Urql.useQuery<PeriodAnalysisChartQuery, PeriodAnalysisChartQueryVariables>({ query: PeriodAnalysisChartDocument, ...options });
};
export const CycleTimeDocument = gql`
    query CycleTime($filter: IdealCycleTimeChartFilter) {
  cycleTime(filter: $filter) {
    delta
    count
  }
}
    `;

export function useCycleTimeQuery(options?: Omit<Urql.UseQueryArgs<CycleTimeQueryVariables>, 'query'>) {
  return Urql.useQuery<CycleTimeQuery, CycleTimeQueryVariables>({ query: CycleTimeDocument, ...options });
};
export const LineTitleListDocument = gql`
    query LineTitleList {
  lines(pagination: {limit: 9999}) {
    value {
      id
      code
      name
    }
  }
}
    `;

export function useLineTitleListQuery(options?: Omit<Urql.UseQueryArgs<LineTitleListQueryVariables>, 'query'>) {
  return Urql.useQuery<LineTitleListQuery, LineTitleListQueryVariables>({ query: LineTitleListDocument, ...options });
};
export const LineDashboardListDocument = gql`
    query LineDashboardList($factoryId: ID!, $disabled: Boolean) {
  lines(
    filter: {factoryId: $factoryId, disabled: $disabled}
    pagination: {limit: 9999}
  ) {
    value {
      id
      code
      name
      disabled
    }
  }
}
    `;

export function useLineDashboardListQuery(options: Omit<Urql.UseQueryArgs<LineDashboardListQueryVariables>, 'query'>) {
  return Urql.useQuery<LineDashboardListQuery, LineDashboardListQueryVariables>({ query: LineDashboardListDocument, ...options });
};
export const WorkshiftAtDocument = gql`
    query WorkshiftAt($time: ISODate) {
  workshiftAt(time: $time) {
    name
    duration
    startingAt
    endingAt
  }
}
    `;

export function useWorkshiftAtQuery(options?: Omit<Urql.UseQueryArgs<WorkshiftAtQueryVariables>, 'query'>) {
  return Urql.useQuery<WorkshiftAtQuery, WorkshiftAtQueryVariables>({ query: WorkshiftAtDocument, ...options });
};
export const DashboardDocument = gql`
    query Dashboard($lineId: ID!) {
  line(id: $lineId) {
    __typename
    id
    name
    code
    description
    nominalBottleneck {
      id
      idealCycleTime
      currentState(onlyCurrentShift: true) {
        production
      }
    }
    machines {
      __typename
      id
      name
      code
      description
      disabled
      maxSpeed
      lineId
      positionX
      positionY
      lastItemTime
      idealCycleTime
      currentRuntimeOptions {
        eventThresholds {
          stopCycle
          normalCycle
          smallStopCycle
        }
      }
      currentState(onlyCurrentShift: true) {
        __typename
        time
        status
        hasChangedStatus
        isInstantBottleneck
        isNominalBottleneck
        isLastMachine
        itemType {
          code
          name
        }
        oee
        production
        projection
        performance
        availability
        stopTime
        stopCount
        smallStopCount
        smallStopTime
        machineId
        speed
        meanSpeed
        delta
      }
    }
  }
  conveyors(filter: {lineId: $lineId}, pagination: {limit: 9999}) {
    value {
      id
      code
      type
      origin {
        id
        code
        currentState(onlyCurrentShift: true) {
          status
          speed
        }
      }
      target {
        id
        code
      }
      handleFrom
      handleTo
    }
  }
  currentStateOfLine(lineId: $lineId, onlyCurrentShift: true) {
    __typename
    time
    status
    hasChangedStatus
    isInstantBottleneck
    isNominalBottleneck
    isLastMachine
    oee
    production
    projection
    performance
    availability
    stopTime
    stopCount
    smallStopCount
    smallStopTime
    machineId
    speed
    meanSpeed
    delta
    runDelta
    previousStatus
    previousRunDelta
    itemType {
      code
      name
    }
    machine {
      idealCycleTime
      currentRuntimeOptions {
        eventThresholds {
          stopCycle
          smallStopCycle
          normalCycle
        }
      }
    }
  }
}
    `;

export function useDashboardQuery(options: Omit<Urql.UseQueryArgs<DashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<DashboardQuery, DashboardQueryVariables>({ query: DashboardDocument, ...options });
};
export const TimelineEventDocument = gql`
    subscription TimelineEvent($lineId: ID!) {
  machineStateCreated(filter: {lineId: $lineId, onlyLastMachine: true}) {
    delta
    status
    time
  }
}
    `;

export function useTimelineEventSubscription<TData = TimelineEventSubscription>(options: Omit<Urql.UseSubscriptionArgs<TimelineEventSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<TimelineEventSubscription, TData>) {
  return Urql.useSubscription<TimelineEventSubscription, TData, TimelineEventSubscriptionVariables>({ query: TimelineEventDocument, ...options }, handler);
};
export const PossibleFailuresDocument = gql`
    query possibleFailures($offset: Int!, $limit: Int!) {
  scrapPossibleFailures(pagination: {limit: $limit, offset: $offset}) {
    value {
      id
      name
      description
      createdAt
    }
    count
    hasNext
  }
}
    `;

export function usePossibleFailuresQuery(options: Omit<Urql.UseQueryArgs<PossibleFailuresQueryVariables>, 'query'>) {
  return Urql.useQuery<PossibleFailuresQuery, PossibleFailuresQueryVariables>({ query: PossibleFailuresDocument, ...options });
};
export const RegisterDefectDocument = gql`
    mutation registerDefect($name: String!, $description: String!) {
  createScrapPossibleFailure(
    scrapPossibleFailure: {name: $name, description: $description}
  ) {
    id
  }
}
    `;

export function useRegisterDefectMutation() {
  return Urql.useMutation<RegisterDefectMutation, RegisterDefectMutationVariables>(RegisterDefectDocument);
};
export const UpdateDefectDocument = gql`
    mutation updateDefect($id: ID!, $name: String!, $description: String!) {
  updateScrapPossibleFailure(
    id: $id
    scrapPossibleFailure: {name: $name, description: $description}
  ) {
    id
    name
    description
  }
}
    `;

export function useUpdateDefectMutation() {
  return Urql.useMutation<UpdateDefectMutation, UpdateDefectMutationVariables>(UpdateDefectDocument);
};
export const DeleteDefectDocument = gql`
    mutation deleteDefect($id: ID!) {
  deleteScrapPossibleFailure(id: $id) {
    name
  }
}
    `;

export function useDeleteDefectMutation() {
  return Urql.useMutation<DeleteDefectMutation, DeleteDefectMutationVariables>(DeleteDefectDocument);
};
export const FactoriesNameDocument = gql`
    query FactoriesName {
  factories(pagination: {limit: 9999}) {
    value {
      id
      code
      name
      lines {
        id
        name
        disabled
      }
    }
  }
}
    `;

export function useFactoriesNameQuery(options?: Omit<Urql.UseQueryArgs<FactoriesNameQueryVariables>, 'query'>) {
  return Urql.useQuery<FactoriesNameQuery, FactoriesNameQueryVariables>({ query: FactoriesNameDocument, ...options });
};
export const FactoriesDocument = gql`
    query Factories($offset: Int!, $limit: Int!) {
  factories(pagination: {limit: $limit, offset: $offset}) {
    value {
      id
      code
      name
      timezone
      createdAt
    }
    count
    hasNext
  }
}
    `;

export function useFactoriesQuery(options: Omit<Urql.UseQueryArgs<FactoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<FactoriesQuery, FactoriesQueryVariables>({ query: FactoriesDocument, ...options });
};
export const CreateFactoryDocument = gql`
    mutation createFactory($name: String!, $code: String!, $timezone: String!) {
  createFactory(factory: {name: $name, code: $code, timezone: $timezone}) {
    name
    code
    timezone
  }
}
    `;

export function useCreateFactoryMutation() {
  return Urql.useMutation<CreateFactoryMutation, CreateFactoryMutationVariables>(CreateFactoryDocument);
};
export const UpdateFactoryDocument = gql`
    mutation updateFactory($id: ID!, $name: String!, $code: String!, $timezone: String!) {
  updateFactory(id: $id, factory: {name: $name, code: $code, timezone: $timezone}) {
    name
    code
    timezone
  }
}
    `;

export function useUpdateFactoryMutation() {
  return Urql.useMutation<UpdateFactoryMutation, UpdateFactoryMutationVariables>(UpdateFactoryDocument);
};
export const DeleteFactoryDocument = gql`
    mutation deleteFactory($id: ID!) {
  deleteFactory(id: $id) {
    id
  }
}
    `;

export function useDeleteFactoryMutation() {
  return Urql.useMutation<DeleteFactoryMutation, DeleteFactoryMutationVariables>(DeleteFactoryDocument);
};
export const GroupListDocument = gql`
    query GroupList($factoryId: ID, $lineId: ID, $workShift: [WorkShift!], $offset: Int!, $limit: Int!) {
  groups(
    filter: {factoryId: $factoryId, lineId: $lineId, workShift: $workShift}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      id
      name
      sector
      workShift
      line {
        id
        code
      }
      factory {
        id
        name
      }
    }
    count
  }
}
    `;

export function useGroupListQuery(options: Omit<Urql.UseQueryArgs<GroupListQueryVariables>, 'query'>) {
  return Urql.useQuery<GroupListQuery, GroupListQueryVariables>({ query: GroupListDocument, ...options });
};
export const RegisterGroupDocument = gql`
    mutation RegisterGroup($name: String!, $factoryId: ID!, $lineId: ID, $sector: Sector!, $workShift: WorkShift!) {
  createGroup(
    group: {name: $name, factoryId: $factoryId, lineId: $lineId, sector: $sector, workShift: $workShift}
  ) {
    id
  }
}
    `;

export function useRegisterGroupMutation() {
  return Urql.useMutation<RegisterGroupMutation, RegisterGroupMutationVariables>(RegisterGroupDocument);
};
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($id: ID!, $name: String, $factoryId: ID, $lineId: ID, $sector: Sector, $workShift: WorkShift) {
  updateGroup(
    id: $id
    group: {name: $name, factoryId: $factoryId, lineId: $lineId, sector: $sector, workShift: $workShift}
  ) {
    id
  }
}
    `;

export function useUpdateGroupMutation() {
  return Urql.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument);
};
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($id: ID!) {
  deleteGroup(id: $id) {
    id
  }
}
    `;

export function useDeleteGroupMutation() {
  return Urql.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument);
};
export const AllGroupsDocument = gql`
    query AllGroups {
  groups(pagination: {limit: 9999, offset: 0}) {
    value {
      id
      name
      lineId
      line {
        id
        name
      }
    }
  }
}
    `;

export function useAllGroupsQuery(options?: Omit<Urql.UseQueryArgs<AllGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllGroupsQuery, AllGroupsQueryVariables>({ query: AllGroupsDocument, ...options });
};
export const GetInfoOfDetectorGroupDocument = gql`
    query getInfoOfDetectorGroup($id: ID!) {
  group(id: $id) {
    id
    name
    lineId
    workShift
    line {
      id
      name
    }
  }
}
    `;

export function useGetInfoOfDetectorGroupQuery(options: Omit<Urql.UseQueryArgs<GetInfoOfDetectorGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<GetInfoOfDetectorGroupQuery, GetInfoOfDetectorGroupQueryVariables>({ query: GetInfoOfDetectorGroupDocument, ...options });
};
export const ItemsDocument = gql`
    query items($offset: Int!, $limit: Int!) {
  itemTypes(pagination: {limit: $limit, offset: $offset}) {
    value {
      id
      name
      code
      description
      createdAt
    }
    count
    hasNext
  }
}
    `;

export function useItemsQuery(options: Omit<Urql.UseQueryArgs<ItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ItemsQuery, ItemsQueryVariables>({ query: ItemsDocument, ...options });
};
export const RegisterItemDocument = gql`
    mutation registerItem($name: String!, $code: String!, $description: String!) {
  createItemType(itemType: {name: $name, code: $code, description: $description}) {
    name
    code
    description
  }
}
    `;

export function useRegisterItemMutation() {
  return Urql.useMutation<RegisterItemMutation, RegisterItemMutationVariables>(RegisterItemDocument);
};
export const UpdateItemDocument = gql`
    mutation updateItem($id: ID!, $name: String, $code: String, $description: String) {
  updateItemType(
    id: $id
    itemType: {name: $name, code: $code, description: $description}
  ) {
    name
    code
    description
  }
}
    `;

export function useUpdateItemMutation() {
  return Urql.useMutation<UpdateItemMutation, UpdateItemMutationVariables>(UpdateItemDocument);
};
export const DeleteItemDocument = gql`
    mutation deleteItem($id: ID!) {
  deleteItemType(id: $id) {
    id
    name
  }
}
    `;

export function useDeleteItemMutation() {
  return Urql.useMutation<DeleteItemMutation, DeleteItemMutationVariables>(DeleteItemDocument);
};
export const JustifiableStopsDocument = gql`
    query JustifiableStops($offset: Int!, $limit: Int!, $affect: Boolean, $factoryId: ID, $lineId: ID, $machineId: ID, $workShift: [WorkShift!], $stopTag: [String!], $reasonTag: [String!], $lossTag: [String!], $states: [JustificationState!], $startDate: ISODate, $endDate: ISODate) {
  justifiableStops(
    filter: {states: $states, affectAvailability: $affect, factoryId: $factoryId, lineId: $lineId, machineId: $machineId, workShift: $workShift, stop: $stopTag, reason: $reasonTag, loss: $lossTag, startDate: $startDate, endDate: $endDate}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      id
      affectAvailability
      line {
        id
        code
        factory {
          id
          code
        }
      }
      state
      workShift
      machine {
        code
      }
      justification {
        stop
        loss
        reason
        description
        user
        machine
        machineCode
      }
      startedAt
      endedAt
    }
    count
    hasNext
  }
}
    `;

export function useJustifiableStopsQuery(options: Omit<Urql.UseQueryArgs<JustifiableStopsQueryVariables>, 'query'>) {
  return Urql.useQuery<JustifiableStopsQuery, JustifiableStopsQueryVariables>({ query: JustifiableStopsDocument, ...options });
};
export const AggregatedStopTimeByDocument = gql`
    query AggregatedStopTimeBy($filter: StopTimeByFilter) {
  aggregatedStopTimeBy(filter: $filter) {
    by
    data {
      name
      duration
    }
  }
}
    `;

export function useAggregatedStopTimeByQuery(options?: Omit<Urql.UseQueryArgs<AggregatedStopTimeByQueryVariables>, 'query'>) {
  return Urql.useQuery<AggregatedStopTimeByQuery, AggregatedStopTimeByQueryVariables>({ query: AggregatedStopTimeByDocument, ...options });
};
export const MachinesDocument = gql`
    query Machines($lineId: ID) {
  machines(filter: {lineId: $lineId}, pagination: {limit: 9999, offset: 0}) {
    value {
      id
      name
      code
      possibleProblems {
        stop
        reason
        loss
      }
      positionX
      positionY
    }
    count
    hasNext
  }
}
    `;

export function useMachinesQuery(options?: Omit<Urql.UseQueryArgs<MachinesQueryVariables>, 'query'>) {
  return Urql.useQuery<MachinesQuery, MachinesQueryVariables>({ query: MachinesDocument, ...options });
};
export const JustifyStopDocument = gql`
    mutation JustifyStop($affectAvailability: Boolean!, $id: ID!, $user: String!, $description: String, $machine: ID!, $reasonTag: String!, $lossTag: String!, $stopTag: String!) {
  justifyStop(
    id: $id
    justification: {affectAvailability: $affectAvailability, user: $user, description: $description, machine: $machine, reason: $reasonTag, loss: $lossTag, stop: $stopTag}
  ) {
    id
    lineId
  }
}
    `;

export function useJustifyStopMutation() {
  return Urql.useMutation<JustifyStopMutation, JustifyStopMutationVariables>(JustifyStopDocument);
};
export const SpecificNotificationStopDocument = gql`
    query SpecificNotificationStop($id: ID!) {
  justifiableStop(id: $id) {
    id
    lineId
    line {
      code
    }
    machine {
      id
      code
    }
    startedAt
    endedAt
    state
    justification {
      stop
      loss
      reason
      description
      user
      machine
      machineCode
    }
  }
}
    `;

export function useSpecificNotificationStopQuery(options: Omit<Urql.UseQueryArgs<SpecificNotificationStopQueryVariables>, 'query'>) {
  return Urql.useQuery<SpecificNotificationStopQuery, SpecificNotificationStopQueryVariables>({ query: SpecificNotificationStopDocument, ...options });
};
export const LastMachineIdDocument = gql`
    query LastMachineId($id: ID!) {
  line(id: $id) {
    lastMachineId
  }
}
    `;

export function useLastMachineIdQuery(options: Omit<Urql.UseQueryArgs<LastMachineIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LastMachineIdQuery, LastMachineIdQueryVariables>({ query: LastMachineIdDocument, ...options });
};
export const RegisterLineDocument = gql`
    mutation RegisterLine($name: String!, $code: String!, $description: String, $stopsThreshold: Float!, $factoryId: ID!) {
  createLine(
    line: {name: $name, code: $code, description: $description, stopsThreshold: $stopsThreshold, factoryId: $factoryId}
  ) {
    id
  }
}
    `;

export function useRegisterLineMutation() {
  return Urql.useMutation<RegisterLineMutation, RegisterLineMutationVariables>(RegisterLineDocument);
};
export const LineListDocument = gql`
    query LineList($offset: Int!, $limit: Int!, $factoryId: ID) {
  lines(
    pagination: {limit: $limit, offset: $offset}
    filter: {factoryId: $factoryId}
  ) {
    value {
      id
      name
      code
      description
      factory {
        id
        name
      }
      machines {
        id
        name
      }
      autoLastMachine
      lastMachine {
        id
        name
      }
      newLastMachineAuto
      newLastMachine {
        id
        name
      }
      autoBottleneckMachine
      nominalBottleneck {
        id
        name
      }
      stopsThreshold
      disabled
      createdAt
    }
    count
    hasNext
  }
}
    `;

export function useLineListQuery(options: Omit<Urql.UseQueryArgs<LineListQueryVariables>, 'query'>) {
  return Urql.useQuery<LineListQuery, LineListQueryVariables>({ query: LineListDocument, ...options });
};
export const UpdateLineDocument = gql`
    mutation UpdateLine($id: ID!, $name: String, $code: String, $description: String, $stopsThreshold: Float!, $factoryId: ID, $lastMachineId: String, $newLastMachineId: String, $newLastMachineAuto: Boolean, $bottleneckMachineId: String) {
  updateLine(
    id: $id
    line: {name: $name, code: $code, description: $description, stopsThreshold: $stopsThreshold, factoryId: $factoryId, lastMachineId: $lastMachineId, newLastMachineId: $newLastMachineId, newLastMachineAuto: $newLastMachineAuto, bottleneckMachineId: $bottleneckMachineId}
  ) {
    id
    name
    description
    disabled
  }
}
    `;

export function useUpdateLineMutation() {
  return Urql.useMutation<UpdateLineMutation, UpdateLineMutationVariables>(UpdateLineDocument);
};
export const DisableLineDocument = gql`
    mutation DisableLine($id: ID!, $disabled: Boolean!) {
  disableLine(id: $id, disabled: $disabled) {
    id
    name
  }
}
    `;

export function useDisableLineMutation() {
  return Urql.useMutation<DisableLineMutation, DisableLineMutationVariables>(DisableLineDocument);
};
export const DeleteLineDocument = gql`
    mutation DeleteLine($id: ID!) {
  deleteLine(id: $id) {
    name
  }
}
    `;

export function useDeleteLineMutation() {
  return Urql.useMutation<DeleteLineMutation, DeleteLineMutationVariables>(DeleteLineDocument);
};
export const LineHistoryDocument = gql`
    query LineHistory($offset: Int!, $limit: Int!, $lineId: ID, $workShift: [WorkShift!], $startDate: ISODate, $endDate: ISODate) {
  machineStates(
    filter: {onlyLastOfWorkShift: true, onlyLastMachine: true, lineId: $lineId, workShift: $workShift, startDate: $startDate, endDate: $endDate}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      oee
      performance
      availability
      production
      stopTime
      stopCount
      workShift
      time
      lossHP
      lossProduction
      machine {
        id
        line {
          id
          code
        }
      }
    }
    count
    hasNext
  }
}
    `;

export function useLineHistoryQuery(options: Omit<Urql.UseQueryArgs<LineHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<LineHistoryQuery, LineHistoryQueryVariables>({ query: LineHistoryDocument, ...options });
};
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    token
    profile
    refreshToken
    firstName
    lastName
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const LossesDocument = gql`
    query losses($offset: Int!, $limit: Int!) {
  stopTags(pagination: {limit: $limit, offset: $offset}, filter: {tagType: LOSS}) {
    value {
      id
      name
      description
      createdAt
    }
    count
    hasNext
  }
}
    `;

export function useLossesQuery(options: Omit<Urql.UseQueryArgs<LossesQueryVariables>, 'query'>) {
  return Urql.useQuery<LossesQuery, LossesQueryVariables>({ query: LossesDocument, ...options });
};
export const RegisterLossDocument = gql`
    mutation registerLoss($name: String!, $description: String!) {
  createStopTag(
    stopTag: {name: $name, description: $description, tagType: LOSS, active: true}
  ) {
    id
    name
    description
  }
}
    `;

export function useRegisterLossMutation() {
  return Urql.useMutation<RegisterLossMutation, RegisterLossMutationVariables>(RegisterLossDocument);
};
export const UpdateLossDocument = gql`
    mutation updateLoss($id: ID!, $name: String!, $description: String!) {
  updateStopTag(id: $id, stopTag: {name: $name, description: $description}) {
    id
    name
    description
  }
}
    `;

export function useUpdateLossMutation() {
  return Urql.useMutation<UpdateLossMutation, UpdateLossMutationVariables>(UpdateLossDocument);
};
export const DeleteLossDocument = gql`
    mutation deleteLoss($id: ID!) {
  deleteStopTag(id: $id) {
    id
    name
  }
}
    `;

export function useDeleteLossMutation() {
  return Urql.useMutation<DeleteLossMutation, DeleteLossMutationVariables>(DeleteLossDocument);
};
export const MachineListDocument = gql`
    query MachineList($offset: Int!, $lineId: ID, $limit: Int!) {
  machines(
    filter: {lineId: $lineId, deleted: false}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      id
      name
      code
      unit
      description
      line {
        id
        code
        lastMachineId
      }
      disabled
      idealCycleTime
      createdAt
      runtimeOptions {
        eventThresholds {
          normalCycle
          smallStopCycle
          stopCycle
        }
      }
      possibleProblems {
        stop
        loss
        reason
      }
      positionX
      positionY
      possibleDefects
      mandatoryJustification
    }
    count
    hasNext
  }
}
    `;

export function useMachineListQuery(options: Omit<Urql.UseQueryArgs<MachineListQueryVariables>, 'query'>) {
  return Urql.useQuery<MachineListQuery, MachineListQueryVariables>({ query: MachineListDocument, ...options });
};
export const DeleteMachineDocument = gql`
    mutation DeleteMachine($id: ID!) {
  deleteMachine(id: $id) {
    name
  }
}
    `;

export function useDeleteMachineMutation() {
  return Urql.useMutation<DeleteMachineMutation, DeleteMachineMutationVariables>(DeleteMachineDocument);
};
export const DisableMachineDocument = gql`
    mutation DisableMachine($id: ID!, $active: Boolean!) {
  disableMachine(id: $id, disabled: $active) {
    id
    name
  }
}
    `;

export function useDisableMachineMutation() {
  return Urql.useMutation<DisableMachineMutation, DisableMachineMutationVariables>(DisableMachineDocument);
};
export const RegisterMachineDocument = gql`
    mutation RegisterMachine($lineId: ID!, $name: String!, $code: String!, $description: String, $idealCycleTime: Float!, $unit: Unit!, $positionX: Int, $positionY: Int, $normalCycle: Float!, $smallStopCycle: Float!, $stopCycle: Float!, $possibleProblems: [PossibleProblemInput!]!, $possibleDefects: [String!], $mandatoryJustification: Boolean!) {
  createMachine(
    machine: {lineId: $lineId, name: $name, code: $code, description: $description, idealCycleTime: $idealCycleTime, unit: $unit, positionX: $positionX, positionY: $positionY, normalCycle: $normalCycle, smallStopCycle: $smallStopCycle, stopCycle: $stopCycle, possibleProblems: $possibleProblems, possibleDefects: $possibleDefects, mandatoryJustification: $mandatoryJustification}
  ) {
    id
    name
  }
}
    `;

export function useRegisterMachineMutation() {
  return Urql.useMutation<RegisterMachineMutation, RegisterMachineMutationVariables>(RegisterMachineDocument);
};
export const UpdateMachineDocument = gql`
    mutation UpdateMachine($id: ID!, $lineId: ID, $name: String, $code: String, $description: String, $idealCycleTime: Float, $unit: Unit, $positionX: Int, $positionY: Int, $normalCycle: Float, $smallStopCycle: Float, $stopCycle: Float, $possibleProblems: [PossibleProblemInput!], $possibleDefects: [String!], $mandatoryJustification: Boolean) {
  updateMachine(
    id: $id
    machine: {lineId: $lineId, name: $name, code: $code, mandatoryJustification: $mandatoryJustification, description: $description, idealCycleTime: $idealCycleTime, unit: $unit, positionX: $positionX, positionY: $positionY, normalCycle: $normalCycle, smallStopCycle: $smallStopCycle, stopCycle: $stopCycle, possibleProblems: $possibleProblems, possibleDefects: $possibleDefects}
  ) {
    id
    name
  }
}
    `;

export function useUpdateMachineMutation() {
  return Urql.useMutation<UpdateMachineMutation, UpdateMachineMutationVariables>(UpdateMachineDocument);
};
export const MachineHistoryDocument = gql`
    query MachineHistory($offset: Int!, $limit: Int!, $lineId: ID, $machineId: ID, $workShift: [WorkShift!], $startDate: ISODate, $endDate: ISODate) {
  machineStates(
    filter: {onlyLastOfWorkShift: true, lineId: $lineId, machineId: $machineId, workShift: $workShift, startDate: $startDate, endDate: $endDate}
    pagination: {limit: $limit, offset: $offset}
  ) {
    count
    value {
      workShift
      oee
      stopCount
      stopTime
      time
      production
      amount
      status
      machine {
        idealCycleTime
        name
        code
        id
        mandatoryJustification
        line {
          name
          code
          id
        }
      }
    }
  }
}
    `;

export function useMachineHistoryQuery(options: Omit<Urql.UseQueryArgs<MachineHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<MachineHistoryQuery, MachineHistoryQueryVariables>({ query: MachineHistoryDocument, ...options });
};
export const AllMachinesDocument = gql`
    query AllMachines {
  machines(pagination: {limit: 9999}) {
    value {
      id
      code
    }
  }
}
    `;

export function useAllMachinesQuery(options?: Omit<Urql.UseQueryArgs<AllMachinesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllMachinesQuery, AllMachinesQueryVariables>({ query: AllMachinesDocument, ...options });
};
export const NotificationsDocument = gql`
    query Notifications($cursor: String, $limit: Int, $offset: Int) {
  notifications(pagination: {cursor: $cursor, limit: $limit, offset: $offset}) {
    value {
      id
      lineId
      title
      originId
      scope
      message
      time
      type
      metadata {
        duration
      }
    }
    count
    hasNext
  }
}
    `;

export function useNotificationsQuery(options?: Omit<Urql.UseQueryArgs<NotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<NotificationsQuery, NotificationsQueryVariables>({ query: NotificationsDocument, ...options });
};
export const OeeChartDocument = gql`
    query OEEChart($lineId: ID, $machineId: ID, $onlyLast: Boolean!, $workShift: [WorkShift!], $startDate: ISODate, $endDate: ISODate) {
  machineStates(
    filter: {onlyLastMachine: $onlyLast, lineId: $lineId, machineId: $machineId, workShift: $workShift, startDate: $startDate, endDate: $endDate}
    pagination: {limit: 9999}
  ) {
    value {
      workShift
      time
      oee
      performance
      availability
    }
    count
  }
}
    `;

export function useOeeChartQuery(options: Omit<Urql.UseQueryArgs<OeeChartQueryVariables>, 'query'>) {
  return Urql.useQuery<OeeChartQuery, OeeChartQueryVariables>({ query: OeeChartDocument, ...options });
};
export const OverviewDocument = gql`
    query Overview($factoryId: ID!) {
  overview(filter: {factoryId: $factoryId}) {
    lineId
    lineCode
    status
    currentShift {
      oee
      production
      projection
    }
    previousShift {
      oee
      production
      projection
    }
    lastShift {
      oee
      production
      projection
    }
    day {
      oee
      production
      projection
    }
    month {
      oee
      production
      projection
    }
  }
}
    `;

export function useOverviewQuery(options: Omit<Urql.UseQueryArgs<OverviewQueryVariables>, 'query'>) {
  return Urql.useQuery<OverviewQuery, OverviewQueryVariables>({ query: OverviewDocument, ...options });
};
export const TimelineOverviewDocument = gql`
    subscription TimelineOverview($factoryId: ID!, $offset: Int!) {
  overviewLineStateCreated(
    factoryId: $factoryId
    pagination: {offset: $offset, limit: 6}
  ) {
    lineId
    idealCycleTime
    thresholds {
      normalCycle
      stopCycle
    }
    events {
      status
      delta
      time
    }
  }
}
    `;

export function useTimelineOverviewSubscription<TData = TimelineOverviewSubscription>(options: Omit<Urql.UseSubscriptionArgs<TimelineOverviewSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<TimelineOverviewSubscription, TData>) {
  return Urql.useSubscription<TimelineOverviewSubscription, TData, TimelineOverviewSubscriptionVariables>({ query: TimelineOverviewDocument, ...options }, handler);
};
export const OverviewLinesDocument = gql`
    query OverviewLines($factoryId: ID!, $offset: Int!) {
  lines(filter: {factoryId: $factoryId}, pagination: {offset: $offset, limit: 6}) {
    value {
      id
      name
      code
    }
    count
  }
}
    `;

export function useOverviewLinesQuery(options: Omit<Urql.UseQueryArgs<OverviewLinesQueryVariables>, 'query'>) {
  return Urql.useQuery<OverviewLinesQuery, OverviewLinesQueryVariables>({ query: OverviewLinesDocument, ...options });
};
export const ParameterValueListDocument = gql`
    query ParameterValueList($code: String, $name: String, $lineId: ID, $machineId: ID, $itemTypeId: ID, $type: ParameterType, $unit: Unit, $workShifts: [WorkShift!], $startDate: ISODate, $endDate: ISODate, $offset: Int!, $limit: Int!, $aboveSuperiorLimit: Boolean, $belowInferiorLimit: Boolean) {
  parameterValues(
    filter: {code: $code, name: $name, lineId: $lineId, machineId: $machineId, itemTypeId: $itemTypeId, type: $type, unit: $unit, workShifts: $workShifts, startDate: $startDate, endDate: $endDate, aboveSuperiorLimit: $aboveSuperiorLimit, belowInferiorLimit: $belowInferiorLimit}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      value
      unit
      time
      workShift
      superiorLimit
      inferiorLimit
      aboveSuperiorLimit
      belowInferiorLimit
      parameterName
      parameterType
      machineName
      lineCode
      itemTypeName
    }
    count
    hasNext
  }
}
    `;

export function useParameterValueListQuery(options: Omit<Urql.UseQueryArgs<ParameterValueListQueryVariables>, 'query'>) {
  return Urql.useQuery<ParameterValueListQuery, ParameterValueListQueryVariables>({ query: ParameterValueListDocument, ...options });
};
export const ParameterNamesDocument = gql`
    query ParameterNames($machineId: ID) {
  parameters(filter: {machineId: $machineId}, pagination: {limit: 9999}) {
    value {
      id
      code
      name
    }
  }
}
    `;

export function useParameterNamesQuery(options?: Omit<Urql.UseQueryArgs<ParameterNamesQueryVariables>, 'query'>) {
  return Urql.useQuery<ParameterNamesQuery, ParameterNamesQueryVariables>({ query: ParameterNamesDocument, ...options });
};
export const ParameterListDocument = gql`
    query ParameterList($offset: Int!, $lineId: ID, $machineId: ID, $limit: Int!) {
  parameters(
    filter: {lineId: $lineId, machineId: $machineId}
    pagination: {offset: $offset, limit: $limit}
  ) {
    value {
      createdAt
      id
      code
      name
      unit
      machine {
        id
        line {
          id
          code
        }
        code
        name
      }
      type
      superiorLimit
      inferiorLimit
    }
    count
  }
}
    `;

export function useParameterListQuery(options: Omit<Urql.UseQueryArgs<ParameterListQueryVariables>, 'query'>) {
  return Urql.useQuery<ParameterListQuery, ParameterListQueryVariables>({ query: ParameterListDocument, ...options });
};
export const RegisterParameterDocument = gql`
    mutation RegisterParameter($code: String!, $name: String!, $unit: Unit!, $machineId: ID!, $superiorLimit: Float!, $inferiorLimit: Float!, $type: ParameterType!) {
  createParameter(
    parameter: {code: $code, name: $name, unit: $unit, machineId: $machineId, superiorLimit: $superiorLimit, inferiorLimit: $inferiorLimit, type: $type}
  ) {
    id
  }
}
    `;

export function useRegisterParameterMutation() {
  return Urql.useMutation<RegisterParameterMutation, RegisterParameterMutationVariables>(RegisterParameterDocument);
};
export const DeleteParameterDocument = gql`
    mutation DeleteParameter($id: ID!) {
  deleteParameter(id: $id) {
    name
  }
}
    `;

export function useDeleteParameterMutation() {
  return Urql.useMutation<DeleteParameterMutation, DeleteParameterMutationVariables>(DeleteParameterDocument);
};
export const UpdateParameterDocument = gql`
    mutation UpdateParameter($id: ID!, $code: String!, $name: String, $unit: Unit, $machineId: ID, $superiorLimit: Float, $inferiorLimit: Float, $type: ParameterType) {
  updateParameter(
    id: $id
    parameter: {code: $code, name: $name, unit: $unit, machineId: $machineId, superiorLimit: $superiorLimit, inferiorLimit: $inferiorLimit, type: $type}
  ) {
    id
  }
}
    `;

export function useUpdateParameterMutation() {
  return Urql.useMutation<UpdateParameterMutation, UpdateParameterMutationVariables>(UpdateParameterDocument);
};
export const ParameterValueChartDocument = gql`
    query ParameterValueChart($startDate: ISODate!, $endDate: ISODate!, $workShifts: [WorkShift!], $machineParameter: [MachineParameter!], $itemTypeId: ID, $minValue: Float, $maxValue: Float) {
  parameterValueChart(
    filter: {startDate: $startDate, endDate: $endDate, workShift: $workShifts, machineParameter: $machineParameter, itemTypeId: $itemTypeId, minValue: $minValue, maxValue: $maxValue}
  ) {
    unit
    machine
    id
    name
    values {
      date
      value
    }
  }
}
    `;

export function useParameterValueChartQuery(options: Omit<Urql.UseQueryArgs<ParameterValueChartQueryVariables>, 'query'>) {
  return Urql.useQuery<ParameterValueChartQuery, ParameterValueChartQueryVariables>({ query: ParameterValueChartDocument, ...options });
};
export const ProductionChartDocument = gql`
    query ProductionChart($lineId: ID, $machineId: ID, $startDate: ISODate!, $endDate: ISODate!, $workShift: [WorkShift!], $period: Period!) {
  production(
    filter: {lineId: $lineId, machineId: $machineId, startDate: $startDate, endDate: $endDate, workShift: $workShift, period: $period}
  ) {
    interval
    day
    accumulated
    projection
    production
  }
}
    `;

export function useProductionChartQuery(options: Omit<Urql.UseQueryArgs<ProductionChartQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionChartQuery, ProductionChartQueryVariables>({ query: ProductionChartDocument, ...options });
};
export const ProductionCycleHistoryDocument = gql`
    query ProductionCycleHistory($offset: Int!, $limit: Int!, $lineId: ID, $machineId: ID, $workShift: [WorkShift!], $startDate: ISODate, $endDate: ISODate) {
  machineStates(
    filter: {lineId: $lineId, machineId: $machineId, workShift: $workShift, startDate: $startDate, endDate: $endDate, productionHistoryFilter: true}
    pagination: {limit: $limit, offset: $offset}
  ) {
    count
    value {
      machineId
      production
      projection
      amount
      status
      workShift
      time
      machine {
        name
        code
        id
        line {
          name
          code
          id
        }
      }
    }
  }
}
    `;

export function useProductionCycleHistoryQuery(options: Omit<Urql.UseQueryArgs<ProductionCycleHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionCycleHistoryQuery, ProductionCycleHistoryQueryVariables>({ query: ProductionCycleHistoryDocument, ...options });
};
export const ProductionHistoryDocument = gql`
    query ProductionHistory($lineId: ID, $machineId: ID, $startDate: ISODate!, $endDate: ISODate!, $workShift: [WorkShift!], $period: Period!) {
  productionHistory(
    filter: {lineId: $lineId, machineId: $machineId, startDate: $startDate, endDate: $endDate, workShift: $workShift, period: $period}
  ) {
    count
    value {
      interval
      lineName
      machineName
      accumulated
      shift
      projection
      production
    }
  }
}
    `;

export function useProductionHistoryQuery(options: Omit<Urql.UseQueryArgs<ProductionHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionHistoryQuery, ProductionHistoryQueryVariables>({ query: ProductionHistoryDocument, ...options });
};
export const ProductionRateMaxCapacityDocument = gql`
    query productionRateMaxCapacity($lineId: ID!) {
  line(id: $lineId) {
    nominalBottleneck {
      name
      maxSpeed
    }
  }
}
    `;

export function useProductionRateMaxCapacityQuery(options: Omit<Urql.UseQueryArgs<ProductionRateMaxCapacityQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionRateMaxCapacityQuery, ProductionRateMaxCapacityQueryVariables>({ query: ProductionRateMaxCapacityDocument, ...options });
};
export const CapacityTrendDocument = gql`
    subscription CapacityTrend($lineId: ID!, $overMinutes: Int!) {
  capacityTrend(lineId: $lineId, overMinutes: $overMinutes) {
    machineId
    machineName
    overMinutes
    capacityBefore
    capacityAfter
    capacityLimit
  }
}
    `;

export function useCapacityTrendSubscription<TData = CapacityTrendSubscription>(options: Omit<Urql.UseSubscriptionArgs<CapacityTrendSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<CapacityTrendSubscription, TData>) {
  return Urql.useSubscription<CapacityTrendSubscription, TData, CapacityTrendSubscriptionVariables>({ query: CapacityTrendDocument, ...options }, handler);
};
export const ReasonsDocument = gql`
    query reasons($offset: Int!, $limit: Int!) {
  stopTags(
    pagination: {limit: $limit, offset: $offset}
    filter: {tagType: REASON}
  ) {
    value {
      id
      name
      description
      createdAt
    }
    count
    hasNext
  }
}
    `;

export function useReasonsQuery(options: Omit<Urql.UseQueryArgs<ReasonsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReasonsQuery, ReasonsQueryVariables>({ query: ReasonsDocument, ...options });
};
export const RegisterReasonDocument = gql`
    mutation registerReason($name: String!, $description: String!) {
  createStopTag(
    stopTag: {name: $name, description: $description, tagType: REASON, active: true}
  ) {
    id
    name
    description
  }
}
    `;

export function useRegisterReasonMutation() {
  return Urql.useMutation<RegisterReasonMutation, RegisterReasonMutationVariables>(RegisterReasonDocument);
};
export const UpdateReasonDocument = gql`
    mutation updateReason($id: ID!, $name: String!, $description: String!) {
  updateStopTag(id: $id, stopTag: {name: $name, description: $description}) {
    id
    name
    description
  }
}
    `;

export function useUpdateReasonMutation() {
  return Urql.useMutation<UpdateReasonMutation, UpdateReasonMutationVariables>(UpdateReasonDocument);
};
export const DeleteReasonDocument = gql`
    mutation deleteReason($id: ID!) {
  deleteStopTag(id: $id) {
    id
    name
  }
}
    `;

export function useDeleteReasonMutation() {
  return Urql.useMutation<DeleteReasonMutation, DeleteReasonMutationVariables>(DeleteReasonDocument);
};
export const RecoverPasswordDocument = gql`
    mutation RecoverPassword($email: String!) {
  recoverPassword(email: $email)
}
    `;

export function useRecoverPasswordMutation() {
  return Urql.useMutation<RecoverPasswordMutation, RecoverPasswordMutationVariables>(RecoverPasswordDocument);
};
export const RefreshDocument = gql`
    mutation Refresh($accessToken: String!, $refreshToken: String!) {
  refresh(tokens: {accessToken: $accessToken, refreshToken: $refreshToken}) {
    token
    refreshToken
    profile
  }
}
    `;

export function useRefreshMutation() {
  return Urql.useMutation<RefreshMutation, RefreshMutationVariables>(RefreshDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!, $token: String!, $password: String!) {
  resetPassword(email: $email, token: $token, password: $password)
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const ScrapFactoriesNameDocument = gql`
    query ScrapFactoriesName {
  factories {
    value {
      id
      code
      name
      lines {
        disabled
      }
    }
  }
}
    `;

export function useScrapFactoriesNameQuery(options?: Omit<Urql.UseQueryArgs<ScrapFactoriesNameQueryVariables>, 'query'>) {
  return Urql.useQuery<ScrapFactoriesNameQuery, ScrapFactoriesNameQueryVariables>({ query: ScrapFactoriesNameDocument, ...options });
};
export const LinesNamesDocument = gql`
    query linesNames($factoryId: ID!) {
  lines(filter: {factoryId: $factoryId}, pagination: {limit: 9999, offset: 0}) {
    value {
      id
      name
      code
    }
    count
    hasNext
  }
}
    `;

export function useLinesNamesQuery(options: Omit<Urql.UseQueryArgs<LinesNamesQueryVariables>, 'query'>) {
  return Urql.useQuery<LinesNamesQuery, LinesNamesQueryVariables>({ query: LinesNamesDocument, ...options });
};
export const AggregatedScrapByDocument = gql`
    query AggregatedScrapBy($filter: ScrapByFilter) {
  aggregatedScrapBy(filter: $filter) {
    by
    data {
      name
      amount
      details {
        name
        amount
      }
    }
  }
}
    `;

export function useAggregatedScrapByQuery(options?: Omit<Urql.UseQueryArgs<AggregatedScrapByQueryVariables>, 'query'>) {
  return Urql.useQuery<AggregatedScrapByQuery, AggregatedScrapByQueryVariables>({ query: AggregatedScrapByDocument, ...options });
};
export const LinesFromFactoryDocument = gql`
    query LinesFromFactory($factoryId: ID) {
  lines(filter: {factoryId: $factoryId}, pagination: {limit: 9999, offset: 0}) {
    value {
      id
      name
      code
      factory {
        id
        name
      }
    }
    count
    hasNext
  }
}
    `;

export function useLinesFromFactoryQuery(options?: Omit<Urql.UseQueryArgs<LinesFromFactoryQueryVariables>, 'query'>) {
  return Urql.useQuery<LinesFromFactoryQuery, LinesFromFactoryQueryVariables>({ query: LinesFromFactoryDocument, ...options });
};
export const LinesFromFactoriesDocument = gql`
    query LinesFromFactories {
  lines(pagination: {limit: 9999, offset: 0}) {
    value {
      id
      name
      code
      factory {
        id
        name
      }
    }
    count
    hasNext
  }
}
    `;

export function useLinesFromFactoriesQuery(options?: Omit<Urql.UseQueryArgs<LinesFromFactoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<LinesFromFactoriesQuery, LinesFromFactoriesQueryVariables>({ query: LinesFromFactoriesDocument, ...options });
};
export const MachinesFromLineDocument = gql`
    query MachinesFromLine($lineId: ID!) {
  machines(filter: {lineId: $lineId}, pagination: {limit: 9999, offset: 0}) {
    value {
      id
      name
      code
      mandatoryJustification
      possibleDefects
    }
    count
    hasNext
  }
}
    `;

export function useMachinesFromLineQuery(options: Omit<Urql.UseQueryArgs<MachinesFromLineQueryVariables>, 'query'>) {
  return Urql.useQuery<MachinesFromLineQuery, MachinesFromLineQueryVariables>({ query: MachinesFromLineDocument, ...options });
};
export const ScrapUserNameDocument = gql`
    query ScrapUserName($idLine: ID!) {
  line(id: $idLine) {
    id
    hasAccess {
      id
      firstName
      lastName
    }
  }
}
    `;

export function useScrapUserNameQuery(options: Omit<Urql.UseQueryArgs<ScrapUserNameQueryVariables>, 'query'>) {
  return Urql.useQuery<ScrapUserNameQuery, ScrapUserNameQueryVariables>({ query: ScrapUserNameDocument, ...options });
};
export const ScrapItemTypeDocument = gql`
    query ScrapItemType {
  itemTypes(pagination: {limit: 9999}) {
    value {
      id
      name
    }
  }
}
    `;

export function useScrapItemTypeQuery(options?: Omit<Urql.UseQueryArgs<ScrapItemTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<ScrapItemTypeQuery, ScrapItemTypeQueryVariables>({ query: ScrapItemTypeDocument, ...options });
};
export const ScrapDefectNameDocument = gql`
    query ScrapDefectName {
  scrapPossibleFailures(pagination: {limit: 9999}) {
    value {
      id
      name
    }
  }
}
    `;

export function useScrapDefectNameQuery(options?: Omit<Urql.UseQueryArgs<ScrapDefectNameQueryVariables>, 'query'>) {
  return Urql.useQuery<ScrapDefectNameQuery, ScrapDefectNameQueryVariables>({ query: ScrapDefectNameDocument, ...options });
};
export const RegisterScrapDocument = gql`
    mutation registerScrap($amount: Float!, $machineId: ID!, $details: CreateScrapInformationInput, $workShift: WorkShift!, $date: ISODate!) {
  createScrap(
    scrap: {amount: $amount, machineId: $machineId, details: $details, workShift: $workShift, date: $date}
  ) {
    id
  }
}
    `;

export function useRegisterScrapMutation() {
  return Urql.useMutation<RegisterScrapMutation, RegisterScrapMutationVariables>(RegisterScrapDocument);
};
export const DeleteScrapDocument = gql`
    mutation DeleteScrap($id: ID!) {
  deleteScrap(id: $id) {
    id
  }
}
    `;

export function useDeleteScrapMutation() {
  return Urql.useMutation<DeleteScrapMutation, DeleteScrapMutationVariables>(DeleteScrapDocument);
};
export const UpdateScrapDocument = gql`
    mutation UpdateScrap($id: ID!, $amount: Float, $machineId: ID, $workShift: WorkShift, $date: ISODate, $details: CreateScrapInformationInput) {
  updateScrap(
    id: $id
    scrap: {amount: $amount, machineId: $machineId, workShift: $workShift, date: $date, details: $details}
  ) {
    id
  }
}
    `;

export function useUpdateScrapMutation() {
  return Urql.useMutation<UpdateScrapMutation, UpdateScrapMutationVariables>(UpdateScrapDocument);
};
export const ScrapDocument = gql`
    query Scrap($id: ID!) {
  scrap(id: $id) {
    id
    amount
    machine {
      id
      code
      line {
        id
        code
        factory {
          id
          name
        }
      }
    }
    details {
      item
      scrapPossibleFailure
      description
      user
      detectorGroup
      generatorGroup
    }
    workShift
    date
  }
}
    `;

export function useScrapQuery(options: Omit<Urql.UseQueryArgs<ScrapQueryVariables>, 'query'>) {
  return Urql.useQuery<ScrapQuery, ScrapQueryVariables>({ query: ScrapDocument, ...options });
};
export const ScrapsDocument = gql`
    query Scraps($factoryId: ID, $lineId: ID, $machineId: ID, $workShift: [WorkShift!], $startDate: ISODate, $endDate: ISODate, $offset: Int!, $limit: Int!, $item: String, $generatorGroup: String, $detectorGroup: String) {
  scraps(
    filter: {factoryId: $factoryId, lineId: $lineId, machineId: $machineId, workShift: $workShift, startDate: $startDate, endDate: $endDate, item: $item, generatorGroup: $generatorGroup, detectorGroup: $detectorGroup}
    pagination: {limit: $limit, offset: $offset}
  ) {
    value {
      id
      amount
      machineId
      machine {
        id
        code
        line {
          id
          code
          factory {
            id
            name
          }
        }
      }
      details {
        factory
        line
        item
        scrapPossibleFailure
        description
        user
        detectorGroup
        generatorGroup
      }
      workShift
      date
    }
    count
    hasNext
  }
}
    `;

export function useScrapsQuery(options: Omit<Urql.UseQueryArgs<ScrapsQueryVariables>, 'query'>) {
  return Urql.useQuery<ScrapsQuery, ScrapsQueryVariables>({ query: ScrapsDocument, ...options });
};
export const GroupsDocument = gql`
    query groups($lineId: ID) {
  groups(filter: {lineId: $lineId}) {
    value {
      id
      name
      sector
      line {
        name
      }
      workShift
      lineId
    }
  }
}
    `;

export function useGroupsQuery(options?: Omit<Urql.UseQueryArgs<GroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<GroupsQuery, GroupsQueryVariables>({ query: GroupsDocument, ...options });
};
export const SmallStopsHistoryDocument = gql`
    query smallStopsHistory($offset: Int!, $limit: Int!, $lineId: ID, $machineId: ID, $workShift: [WorkShift!], $startDate: ISODate, $endDate: ISODate) {
  justifiableSmallStops(
    pagination: {limit: $limit, offset: $offset}
    filter: {lineId: $lineId, machineId: $machineId, workShift: $workShift, startDate: $startDate, endDate: $endDate}
  ) {
    count
    value {
      id
      state
      machineId
      startedAt
      endedAt
      workShift
      machine {
        lineId
        code
        line {
          id
          code
          name
        }
      }
    }
  }
}
    `;

export function useSmallStopsHistoryQuery(options: Omit<Urql.UseQueryArgs<SmallStopsHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<SmallStopsHistoryQuery, SmallStopsHistoryQueryVariables>({ query: SmallStopsHistoryDocument, ...options });
};
export const MachineListFromLineDocument = gql`
    query MachineListFromLine($lineId: ID!) {
  machines(filter: {lineId: $lineId}) {
    value {
      name
      id
      code
      line {
        id
        name
        code
      }
    }
  }
}
    `;

export function useMachineListFromLineQuery(options: Omit<Urql.UseQueryArgs<MachineListFromLineQueryVariables>, 'query'>) {
  return Urql.useQuery<MachineListFromLineQuery, MachineListFromLineQueryVariables>({ query: MachineListFromLineDocument, ...options });
};
export const StopTagsDocument = gql`
    query StopTags($offset: Int!, $tagType: StopTagType!, $limit: Int!) {
  stopTags(
    pagination: {limit: $limit, offset: $offset}
    filter: {tagType: $tagType}
  ) {
    count
    hasNext
    value {
      id
      name
      description
      tagType
      createdAt
    }
  }
}
    `;

export function useStopTagsQuery(options: Omit<Urql.UseQueryArgs<StopTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<StopTagsQuery, StopTagsQueryVariables>({ query: StopTagsDocument, ...options });
};
export const AllStopTagsDocument = gql`
    query AllStopTags($tagType: StopTagType!) {
  stopTags(pagination: {limit: 9999, offset: 0}, filter: {tagType: $tagType}) {
    value {
      id
      name
      description
    }
    count
    hasNext
  }
}
    `;

export function useAllStopTagsQuery(options: Omit<Urql.UseQueryArgs<AllStopTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllStopTagsQuery, AllStopTagsQueryVariables>({ query: AllStopTagsDocument, ...options });
};
export const RegisterStopDocument = gql`
    mutation RegisterStop($name: String!, $description: String!, $tagType: StopTagType!) {
  createStopTag(
    stopTag: {name: $name, description: $description, tagType: $tagType}
  ) {
    id
  }
}
    `;

export function useRegisterStopMutation() {
  return Urql.useMutation<RegisterStopMutation, RegisterStopMutationVariables>(RegisterStopDocument);
};
export const UpdateStopDocument = gql`
    mutation updateStop($id: ID!, $name: String!, $description: String!) {
  updateStopTag(id: $id, stopTag: {name: $name, description: $description}) {
    id
    name
    description
  }
}
    `;

export function useUpdateStopMutation() {
  return Urql.useMutation<UpdateStopMutation, UpdateStopMutationVariables>(UpdateStopDocument);
};
export const DeleteStopDocument = gql`
    mutation deleteStop($id: ID!) {
  deleteStopTag(id: $id) {
    name
  }
}
    `;

export function useDeleteStopMutation() {
  return Urql.useMutation<DeleteStopMutation, DeleteStopMutationVariables>(DeleteStopDocument);
};
export const RegisterUserDocument = gql`
    mutation RegisterUser($firstName: String!, $lastName: String!, $email: String!, $password: String!, $permissions: [ID!]!, $profile: UserProfile!, $groupId: ID) {
  createUser(
    user: {firstName: $firstName, lastName: $lastName, email: $email, password: $password, permissions: $permissions, profile: $profile, groupId: $groupId}
  ) {
    id
  }
}
    `;

export function useRegisterUserMutation() {
  return Urql.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument);
};
export const UserListDocument = gql`
    query UserList($offset: Int!, $hasAcessTo: ID!, $limit: Int!) {
  users(
    pagination: {limit: $limit, offset: $offset}
    filter: {hasAccessTo: $hasAcessTo}
  ) {
    value {
      id
      profile
      email
      firstName
      lastName
      permissions
      active
      groupId
    }
    count
    hasNext
  }
}
    `;

export function useUserListQuery(options: Omit<Urql.UseQueryArgs<UserListQueryVariables>, 'query'>) {
  return Urql.useQuery<UserListQuery, UserListQueryVariables>({ query: UserListDocument, ...options });
};
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $firstName: String, $lastName: String, $email: String, $profile: UserProfile, $permissions: [ID!], $active: Boolean, $groupId: ID) {
  updateUser(
    id: $id
    user: {firstName: $firstName, lastName: $lastName, email: $email, profile: $profile, permissions: $permissions, active: $active, groupId: $groupId}
  ) {
    id
  }
}
    `;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    id
  }
}
    `;

export function useDeleteUserMutation() {
  return Urql.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument);
};
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    profile
    permissions
    firstName
    lastName
    groupId
    group {
      name
      sector
    }
  }
}
    `;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
};